import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  Injector,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { ClientRouteLocatorComponent } from "./client-route-locator/client-route-locator.component";
import { SubRouteRelationshipsModalComponent } from "./sub-route-relationships-modal/sub-route-relationships-modal.component";
import { PermissionDirective } from "app/core/permission/directives/permission.directive";
import { PermissionService } from "app/core/permission/services/permission.service";
import { ConfirmationService } from "app/shared/services/confirmation.service";
import { ConfirmationModalType } from "app/shared/components/confirmation-modal";
import { ROUTES_PERMISSIONS } from "app/common/constants/permission";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { CompanyService } from "../../configuration/company/company.service.service";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import { CommonModule } from "@angular/common";
import {
  ReactiveFormsModule,
  FormsModule,
  FormControl,
  Validators,
  FormBuilder,
  Form,
  FormGroup,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import {
  MatOptionModule,
  MatPseudoCheckbox,
  MatPseudoCheckboxModule,
} from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatSelect,
  MatSelectChange,
  MatSelectModule,
} from "@angular/material/select";
import {
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import {
  MatTableModule,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from "@ng-select/ng-select";
import { RouteAreaService } from "../../routing/route-area/route-area.service";
import RouteAreaAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import {
  ICreateSubRoute,
  MainCollabItem,
} from "./interfaces/create-sub-route.interface";
import SubRouteAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route.entity";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import {
  SUB_ROUTE_IMPORT_FILE_FULL_URL,
  SubRouteService,
} from "./sub-route.service";
import { IUpdateSubRoute } from "./interfaces/update-sub-route.interface";
import RouteAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity";
import { RouteService } from "../route/route.service";
import {
  BusinessPartnerFunctionAttributes,
  RoutingItineraryAttributes,
  RoutingItineraryDetailAttributes,
  SubRouteFunctionAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { SubRouteFunctionService } from "../sub-route-function/sub-route.service";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import BusinessPartnerTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-type/business-partner-type.entity";
import { BusinessPartnerTypeService } from "../../business-partners/business-partner-type/business-partner-type.service";
import { BusinessPartnerFunctionService } from "../../business-partners/business-partner-function/business-partner-function.service";
import { ICreateSubRouteFrequency } from "./sub-routes-frequency/interfaces/create-sub-route-frequency.interface";
import { AddSubRouteFrequency } from "./sub-routes-frequency/sub-route-frequency.component";
import { SubRouteFrequenciesService } from "./sub-routes-frequency/sub-route-frequency.service";
import { AddSubRouteCollaborator } from "./sub-route-collaborator/sub-route-collaborator.component";
import { SubRouteCollaboratorService } from "./sub-route-collaborator/sub-route-collaborator.service";
import { UserMasterService } from "./sub-route-collaborator/user_master.service";
import { ChangeMainCollaboratorModalComponent } from "./change-main-collaborator-modal/change-main-collaborator-modal.component";
import { AddSubRouteItinerary } from "./sub-route-itinerary/sub-route-itinerary.component";
import { SubRouteItineraryService } from "./sub-route-itinerary/sub-route-itinerary.service";
import { SubRouteItineraryAlternativeService } from "./sub-route-itinerary/sub-route-itinerary-alternative.service";
import { AddBusinessPartnerOrderComponent } from "../../business-partners/business-partner/business-partner-order-modal/business-partner-order.component";
import { SubRouteOrderService } from "./sub-route-order/sub-route-order.service";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import FrequenciesAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity";
import SubRouteBusinessPartnersAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequency-bp/sub-route-frequency-bp.entity";
import { SubRouteFrequenciesBPService } from "./sub-routes-frequency/sub-route-frequencies-bp.service";
import {
  CdkDragDrop,
  CdkDropList,
  DragDropModule,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { BusinessPartnerService } from "../../business-partners/business-partner/business-partner.service";
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from "@angular/material/checkbox";
import { DeleteConfirmationComponent } from "../../business-partners/business-partner/delete-modal/delete-modal.component";
import {
  MatButtonToggleGroup,
  MatButtonToggleModule,
} from "@angular/material/button-toggle";
import { SubRouteModelEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/sub-route-model.enum";
import { SubRouteTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/sub-route-type.enum";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import {
  firstValueFrom,
  forkJoin,
  ReplaySubject,
  Subject,
  Subscription,
  take,
  takeUntil,
  skip,
  debounceTime,
  distinctUntilChanged,
  finalize
} from "rxjs";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import { RouteGroupService } from "../route-group/route-group.service";
import { TranslocoModule, TranslocoService } from "@ngneat/transloco";
import { AddSubRouteDeliveryTimes } from "./sub-route-delivery-times/sub-route-delivery-times.component";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import {
  SubRoutePartnersDialogComponent,
  SubRoutePartnersDialogData,
} from "./sub-route-partners/sub-route-partners-dialog.component";
import { AddFrequencies } from "./sub-route-add-frequency/sub-route-add-frequency.component";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { PlantsService } from "../../configuration/plant/plants.service";
import { getCode } from "app/utils/method";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { ICreateSubRouteItinerary } from "./sub-route-itinerary/interfaces/create-route-itinerary.interface";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ItineraryActionEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/itinerary-action.enum";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import VehicleAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle/vehicle.entity";
import { VechicleService } from "../../transport/vechicle/vehicle.service";
import { SUB_ROUTE_COMMERCIAL_CONDITION_MODES } from "./sub-routes-commercial-condition.constants";
import { SubRouteExport } from "./exports/sub-route.export";
import { SUB_ROUTE_TITLE } from "./exports/sub-route.constants";
import { RoutingItineraryService } from "../routing-itinerary/routing-itinerary.service";
import { TripRouteService } from "app/modules/components/sales/trip/trip.service";
import { ModalCreatedTripsComponent } from "./modals/modal-created-trips/modal-created-trips.component";
import { ModalSelectTripsComponent } from "./modals/modal-select-trips/modal-select-trips.component";
import { RouteUpdateConfirmationComponent } from "./modals/route-update-confirmation/route-update-confirmation.component";
import { MatChipsModule } from "@angular/material/chips";
import { ICreateRoutingItinerary } from "../routing-itinerary/interfaces/create-routing-itinerary.interface";
import { RoutingItineraryTypesEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/routing-itinerary-types.enum";
import { RoutingItinerary } from "../routing-itinerary/routing-itinerary.component";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
  MatTreeModule,
} from "@angular/material/tree";
import { FlatTreeControl } from "@angular/cdk/tree";
import ShortRouteAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route/short-route/route.short.entity";
import { ForceCloseTripEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/force-close-trip.enum";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { ImportConfig } from "app/shared/components/excel-import/interfaces/import-config.interface";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { TripCreationPreviewResult } from "app/modules/components/sales/trip/trip-creation-preview.types";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import {
  buildCreateTripsBlockedMessage,
  buildCreateTripsConfirmMessage,
  CREATE_TRIPS_FROM_ITINERARY_MODELS,
  isCreateTripsPreviewBlocked,
} from "./constants/create-trips-preview.constants";
import { t } from "app/core/i18n/i18n";

import {
  ExcelGeneratorService,
  ImportButtonComponent,
} from "app/shared/components/excel-import";
import ShortSalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office-short/sales-office.short.entity";
import ShortRouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/short-route-group/route-group.short.entity";
import { PermissionModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/permission-gps.enum";
import { RoutesDetailByBusinessPartnerVehicleComponent } from "../../modals/routes-detail-by-business-partner-vehicle/routes-detail-by-business-partner-vehicle/routes-detail-by-business-partner-vehicle.component";
import { MatRadioModule } from "@angular/material/radio";
import { BusinessPartnerBySubRoute } from "./interfaces/busines-partner-by-sub-route.interface";
import { RouteOptimizationDrawerComponent } from "./route-optimization/route-optimization-drawer.component";
import { ToggleOptionComponent } from "app/shared/components/form-ui/toggle-option/toggle-option.component";
import { BONUS_HANDLING_OPTIONS } from "app/shared/constants/lists.constant";
import { InvoicedDeliveryCollectionBehaviourEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/invoiced-delivery-collection-behaviour.enum";
import { CommercialCondModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/commercial-condition-mode.enum";
import { DeliveryAssignmentStrategyEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/delivery-assignment-strategy.enum";
import { AuditLogViewerService } from "app/shared/services/audit-log-viewer.service";
import { AUDIT_LOG_COLLECTIONS } from "app/shared/components/audit-log-viewer/audit-log-collections.constants";
import { HasPermissionPipe } from "app/core/permission/pipes/has-permission.pipe";

interface SubRouteNode
  extends SubRouteWithSalesOfficeAUx,
  SubRouteWithRouteGroupAux,
  SubRouteWithTerritoryAUx {
  children?: SubRouteNode[];
}

interface SubRouteFlatNode
  extends SubRouteWithSalesOfficeAUx,
  SubRouteWithRouteGroupAux,
  SubRouteWithTerritoryAUx {
  expandable: boolean;
  levelTree: number;
}

interface SubRouteWithTerritoryAUx extends SubRouteAttributes {
  auxUniqueTerritory?: ShortRouteAttributes;
}

interface SubRouteWithSalesOfficeAUx extends SubRouteAttributes {
  auxUniqueSalesOffice?: ShortSalesOfficeAttributes;
}
interface SubRouteWithRouteGroupAux extends SubRouteAttributes {
  auxUniqueRouteGroup?: ShortRouteGroupAttributes;
}

@Component({
  selector: "app-sub-routes",
  standalone: true,
  templateUrl: "./sub-routes.component.html",
  styleUrl: "./sub-routes.component.scss",
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  imports: [
    MatButtonToggleModule,
    CommonModule,
    MatTableModule,
    MatDialogModule,
    DragDropModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    TranslocoModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatDatepickerModule,
    FormatOtherDateHourPipe,
    AddSubRouteItinerary,
    MatChipsModule,
    MatTreeModule,
    FilterComponent,
    ConfigurationFiltersComponent,
    StatusFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    ImportButtonComponent,
    MatPseudoCheckboxModule,
    MatButtonToggleModule,
    RoutesDetailByBusinessPartnerVehicleComponent,
    MatRadioModule,
    RouterLink,
    HoverMenuDirective,
    ToggleOptionComponent,
    PermissionDirective,
    HasPermissionPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    SubRouteExport,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubRoutesComponent implements OnInit, AfterViewInit, OnDestroy {
  getCode = getCode;
  readonly PERMISSIONS_ASSOCIATIONS = ROUTES_PERMISSIONS.ASSOCIATIONS;
  readonly PERMISSIONS = ROUTES_PERMISSIONS.ROUTES;
  readonly PERMISSIONS_FREQUENCIES = ROUTES_PERMISSIONS.FREQUENCIES;
  readonly PERMISSIONS_INTERLOCUTORS = ROUTES_PERMISSIONS.INTERLOCUTORS;
  readonly PERMISSIONS_ITINERARY = ROUTES_PERMISSIONS.ITINERARY;
  readonly PERMISSIONS_ITINERARY_ALTERNATIVE = ROUTES_PERMISSIONS.ITINERARY_ALTERNATIVE;
  readonly PERMISSIONS_DELIVERY_WINDOWS = ROUTES_PERMISSIONS.DELIVERY_WINDOWS;
  readonly PERMISSIONS_TRIPS = ROUTES_PERMISSIONS.TRIPS;
  readonly PERMISSIONS_EMISSION_POINT = ROUTES_PERMISSIONS.EMISSION_POINT;
  private readonly permissionService = inject(PermissionService);
  private readonly handlerMessage = inject(HandlerMessageService);
  private readonly confirmationService = inject(ConfirmationService);
  isCreatingTripsFromItinerary = false;
  private isInitialized = false;
  //enums
  subRouteTypeEnum = SubRouteTypeEnum;

  displayedColumns: string[] = [
    "type",
    "name",
    "responsibleWithUser",
    // "mainCollaborator",
    // "responsibleBusinessPartner",
    "routes",
    "routeAreas",
    "group",
    "statusId",
    "frecuency",
    "actions",
  ];
  displayedColumnsF: string[] = ["Dias", "Clientes", "Estado", "Acciones"];
  displayedColumnsFWithExpand = ["expand", ...this.displayedColumnsF];
  expandedElement: FrequenciesAttributes | null;

  displayedColumnsI: string[] = [
    "days",
    "action",
    "datetimeStart",
    "datetimeEnd",
    "status",
    "actions",
  ];
  displayedColumnsC: string[] = ["name", "function", "status", "actions"];
  displayedColumnsO: string[] = [
    "days",
    "hourStart",
    "hourEnd",
    "status",
    "actions",
  ];
  currentCreateSubRoute: ICreateSubRoute = this.initializeCreateSubRoute();
  currentUpdateSubRoute: SubRouteAttributes | undefined;
  private originalEditMasterUserId = "";
  private originalEditResponsibleId = "";
  subRouteItineraryList: RoutingItineraryAttributes[] = [];
  subRouteAlternativeItineraryList: RoutingItineraryAttributes[] = [];
  currentCreateFrequency: ICreateSubRouteFrequency =
    this.initializeCreateFrequency();
  selectedCompanyIds: string[] = [];
  businessPartnerFunctionList: BusinessPartnerFunctionAttributes[] = [];
  dataSource: SubRouteAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  warehouseList: WarehouseAttributes[] = [];
  functionList: SubRouteFunctionAttributes[] = [];
  subRouteFunctionSelected: SubRouteFunctionAttributes = null;
  vehicleList: VehicleAttributes[] = [];

  /** control for the selected vehicle */
  public vehicleCtrl: FormControl<VehicleAttributes | any> =
    new FormControl<VehicleAttributes | any>(null);

  /** control for the MatSelect filter keyword */
  public vehicleFilterCtrl: FormControl<string> = new FormControl<string>("");

  /** list of vehicles filtered by search keyword */
  public filteredVehicles: ReplaySubject<VehicleAttributes[]> =
    new ReplaySubject<VehicleAttributes[]>(1);
  routeList: RouteAttributes[] = [];
  businessPartenerFrequencyList: BusinessPartnerBySubRoute[] = [];
  salesOfficeList: SalesOfficeAttributes[] = [];
  subRutaList: SubRouteAttributes[] = [];
  userMasterList: any[] = [];
  mainCollabList: any[] = [];
  businessPartnerFilterTypeList: BusinessPartnerTypeAttributes[] = [];
  businessPartnerRespList: BusinessPartnerAttributes[] = [];
  businessPartnerList: BusinessPartnerAttributes[] = [];
  modelList: { key: SubRouteModelEnum; value: string }[] = [];
  typeList: { key: SubRouteTypeEnum; value: string }[] = [];
  useGpsList: { key: string; value: PermissionModeEnum }[] = [];
  translatedTypes: string[] = [];

  routeGroupList: RouteGroupAttributes[] = [];
  routeAreaList: RouteAreaAttributes[] = [];

  frequencyNames = {
    W: "Semanal",
    Q: "Quincenal",
    M: "Mensual",
    P: "Periódico",
    C: "Personalizado",
  };

  bonusHandlingOptions = BONUS_HANDLING_OPTIONS;

  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;

  searchQuerybp: string = "";
  totalItemsbp: number = 0;
  pageSizebp: number = 50;
  pageIndexbp: number = 0;

  isSecondDivVisible = false;
  additionalContentWidth = 500;

  @ViewChild("viewRoutesModal") viewRoutesModal!: TemplateRef<any>;

  dialogRefRoutes: MatDialogRef<any>;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  typeModal: string = "vehicle";

  userMasterFilterList: any[] = [];
  filteredData: MatTableDataSource<any>;
  filterValue: string = "";
  frequencyTypes: any[] = [];
  public groupedFrequencies: {
    [key: string]: { frequencies: FrequenciesAttributes[] };
  } = {};

  filterAssigned: number | null = null;

  mainTableData = [
    { name: "Cliente A", phone: "111-222-3333", email: "clienteA@example.com" },
    { name: "Cliente B", phone: "444-555-6666", email: "clienteB@example.com" },
  ];

  clientsData: any[] = [];

  private initialWidth: number = 0;
  private startX: number = 0;
  resizeIcon: string = "heroicons_outline:chevron-double-left";
  isSmallScreen: boolean = false;
  flex1Width: number | undefined;
  isFirstPanelExpanded = false;
  tables: { id: string; table: MatTable<any> }[] = [];

  /** control for the selected route for multi-selection */
  public companyControl: FormControl<CompanyAttributes[]> = new FormControl<
    CompanyAttributes[]
  >([], Validators.required);

  /** control for the selected route for multi-selection */
  public functionControl: FormControl<SubRouteFunctionAttributes[]> =
    new FormControl<SubRouteFunctionAttributes[]>([], Validators.required);

  /** control for the selected sales office for multi-selection */
  public salesOfficeControl: FormControl<SalesOfficeAttributes[]> =
    new FormControl<SalesOfficeAttributes[]>([], Validators.required);

  /** control for the selected route for multi-selection */
  public routeGroupControl: FormControl<RouteGroupAttributes[]> =
    new FormControl<RouteGroupAttributes[]>([], Validators.required);

  /** control for the selected route for multi-selection */
  public routeMultiCtrl: FormControl<RouteAttributes[]> = new FormControl<
    RouteAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public routeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredRoutes: ReplaySubject<RouteAttributes[]> = new ReplaySubject<
    RouteAttributes[]
  >(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredRouteCache: RouteAttributes[] = [];

  /** control for the selected routeArea for multi-selection */
  public routeAreaMultiCtrl: FormControl<RouteAreaAttributes[]> =
    new FormControl<RouteAreaAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public routeAreaMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of routeArea filtered by search keyword */
  public filteredRouteAreas: ReplaySubject<RouteAreaAttributes[]> =
    new ReplaySubject<RouteAreaAttributes[]>(1);

  /** local copy of filtered routeArea to help set the toggle all checkbox state */
  protected filteredRouteAreaCache: RouteAreaAttributes[] = [];

  /** control for the selected routeArea for multi-selection */
  public warehouseMultiCtrl: FormControl<WarehouseAttributes[]> =
    new FormControl<WarehouseAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public warehouseMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of warehouses filtered by search keyword */
  public filteredWarehouses: ReplaySubject<WarehouseAttributes[]> =
    new ReplaySubject<WarehouseAttributes[]>(1);

  /** local copy of filtered warehouses to help set the toggle all checkbox state */
  protected filteredWarehouseCache: WarehouseAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;
  plants: any[] = [];

  fileToUpload: File;
  aux_file = false;

  /** control for the selected masterUser for multi-selection */
  public masterUserMultiCtrl: FormControl<any[]> = new FormControl<any[]>([]);

  /** control for the selected masterUser for multi-selection */
  public routeGroupMultiCtrl: FormControl<any[]> = new FormControl<any[]>([]);

  public routeGroupMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of routeArea filtered by search keyword */
  public filteredRouteGroup: ReplaySubject<RouteGroupAttributes[]> =
    new ReplaySubject<RouteGroupAttributes[]>(1);

  /** local copy of filtered routeArea to help set the toggle all checkbox state */
  protected filteredRouteGroupCache: RouteGroupAttributes[] = [];

  subrouteList: SubRouteAttributes[] = [];
  /** control for the selected masterUser for multi-selection */
  public subrouteMultiCtrl: FormControl<any[]> = new FormControl<any[]>([]);

  public subrouteMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of routeArea filtered by search keyword */
  public filteredRoute: ReplaySubject<SubRouteAttributes[]> = new ReplaySubject<
    SubRouteAttributes[]
  >(1);

  /** local copy of filtered routeArea to help set the toggle all checkbox state */
  protected subfilteredRouteCache: SubRouteAttributes[] = [];

  subrouteCList: SubRouteAttributes[] = [];
  /** control for the selected masterUser for multi-selection */
  public subrouteCMultiCtrl: FormControl<any[]> = new FormControl<any[]>([]);

  public subrouteCMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of routeArea filtered by search keyword */
  public filteredCRoute: ReplaySubject<SubRouteAttributes[]> =
    new ReplaySubject<SubRouteAttributes[]>(1);

  /** local copy of filtered routeArea to help set the toggle all checkbox state */
  protected subfilteredCRouteCache: SubRouteAttributes[] = [];

  daysList: { day: string; value: number }[] = [
    { day: "LUNES", value: 1 },
    { day: "MARTES", value: 2 },
    { day: "MIÉRCOLES", value: 3 },
    { day: "JUEVES", value: 4 },
    { day: "VIERNES", value: 5 },
    { day: "SÁBADO", value: 6 },
    { day: "DOMINGO", value: 7 },
  ];
  actionsItinerary: ItineraryActionEnum[] = [];

  currentCreateSubRouteItinerary: ICreateSubRouteItinerary =
    this.initializeCreateSubRouteItinerary();
  isAddingItinerary: boolean = false;
  isAddingItineraryAlternative: boolean = false;

  //Itinerario
  displayedColumnsI2: string[] = [
    "det",
    "datetimeStart",
    "datetimeEnd",
    "status",
    "actions",
  ];
  dataSourceItinerary = new MatTableDataSource<RoutingItineraryAttributes>([]);

  selectedItinerary: RoutingItineraryAttributes | null = null;

  displayedColumnsID2: string[] = ["days", "action", "actions"];
  listItineraryDetail: RoutingItineraryDetailAttributes[] = [];

  currentCreateRoutingItinerary: ICreateRoutingItinerary =
    this.initializeCreateSubRouteItineraryV2();
  currentCreateRoutingItineraryDay: number = null;
  currentCreateRoutingItineraryActions: ItineraryActionEnum[] = [];

  openFormAddRoutingItineraryDetail = false;
  editDetailRoutingItineraryDetail = false;

  //Itinerario Alternativo
  dataSourceItineraryAlternative =
    new MatTableDataSource<RoutingItineraryAttributes>([]);
  selectedItineraryAlternative: RoutingItineraryAttributes | null = null;

  listItineraryAlternativeDetail: RoutingItineraryDetailAttributes[] = [];

  openFormAddRoutingItineraryAlternativeDetail = false;
  editDetailRoutingItineraryAlternativeDetail = false;

  currentCreateRoutingItineraryAlternative: ICreateRoutingItinerary =
    this.initializeCreateSubRouteItineraryV2();
  currentCreateRoutingItineraryAlternativeDay: number = null;
  currentCreateRoutingItineraryAlternativeActions: ItineraryActionEnum[] = [];

  deliveryAssignmentStrategyList: string[] = Object.values(DeliveryAssignmentStrategyEnum);
  commercialConditionModeList: readonly CommercialCondModeEnum[] =
    SUB_ROUTE_COMMERCIAL_CONDITION_MODES;

  private transformer = (
    node: SubRouteNode,
    levelTree: number
  ): SubRouteFlatNode => {
    return {
      ...node,
      expandable: node.children && node.children.length > 0,
      levelTree: levelTree,
    };
  };

  treeControl = new FlatTreeControl<SubRouteFlatNode>(
    (node) => node.levelTree,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.levelTree,
    (node) => node.expandable,
    (node) => node.children
  );

  displayedColumnsTree: string[] = [
    "type",
    "routes",
    "name",
    "responsibleWithUser",
    // "mainCollaborator",
    // "responsibleBusinessPartner",
    "routeAreas",
    "group",
    "statusId",
    "frecuency",
    "actions",
  ];
  dataSourceTree = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );
  auxData: SubRouteWithTerritoryAUx[] = [];
  auxDataSalesOffice: SubRouteWithSalesOfficeAUx[] = [];
  auxDataRouteGroup: SubRouteWithRouteGroupAux[] = [];

  // modeTree: boolean = false;
  selectedMode: string | null = null;

  // Para modeTree, permitir los tres posibles valores más null
  modeTree: "territory" | "salesOffice" | "group" | null = null;

  forceCloseTripList: number[] = Object.values(ForceCloseTripEnum).filter(
    (value): value is number => typeof value === "number"
  );

  invoicedDeliveryCollectionBehaviourList: number[] = Object.values(InvoicedDeliveryCollectionBehaviourEnum).filter(
    (value): value is number => typeof value === "number"
  );

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild("addModalFrequency") addModalFrequency!: TemplateRef<any>;
  @ViewChild("addModalItinerary") addModalItinerary!: TemplateRef<any>;
  @ViewChild("routingItineraryModal") routingItineraryModal!: TemplateRef<any>;
  @ViewChild("addModalOrder") addModalOrder!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
  @ViewChildren(MatTable) mainTables!: QueryList<MatTable<any>>;
  @ViewChild("table", { static: false }) table: MatTable<any>;
  @ViewChildren(CdkDropList) cdkDropLists!: QueryList<CdkDropList>;
  @ViewChild("multiSelect", { static: true }) multiSelect!: MatSelect;
  protected _onDestroy = new Subject<void>();
  private routeLoaded$ = new Subject<void>();

  //BUSCADOR
  searchSubscription: Subscription;
  queryParamsSubscription: Subscription;
  form: FormGroup;
  selectedStatuses: number[] = [];

  // Query param filtering
  private subRoutesCodesToFilter: string[] = [];

  // Lazy loading flags
  loadFiltersData = false;
  companiesLoaded = false;
  routeGroupsLoaded = false;
  plantsLoaded = false;
  routesLoaded = false;
  routeAreasLoaded = false;
  userMastersLoaded = false;

  noPartnerAssigned = false;

  constructor(
    private plantService: PlantsService,
    private renderer: Renderer2,
    private readonly companyService: CompanyService,
    private readonly functionService: SubRouteFunctionService,
    private readonly vehicleService: VechicleService,
    private readonly routeService: RouteService,
    private readonly userMasterService: UserMasterService,
    private readonly frequencyService: SubRouteFrequenciesService,
    private readonly subRouteOrderService: SubRouteOrderService,
    private readonly subRouteCollaboratorService: SubRouteCollaboratorService,
    private readonly businessFunctionService: BusinessPartnerFunctionService,
    private readonly businessTypeService: BusinessPartnerTypeService,
    private readonly warehouseService: WarehouseService,
    private readonly subrouteService: SubRouteService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly itineraryService: SubRouteItineraryService,
    private readonly itineraryAlternativeService: SubRouteItineraryAlternativeService,
    private readonly routingItineraryService: RoutingItineraryService,
    private readonly tripRouteService: TripRouteService,
    private readonly frequencybpService: SubRouteFrequenciesBPService,
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly routeAreasService: RouteAreaService,
    private readonly routeGroupsService: RouteGroupService,
    private readonly businessService: BusinessPartnerService,
    private readonly searchService: SearchService,
    private translocoService: TranslocoService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private subRouteExport: SubRouteExport,
    private injector: Injector,
    private fb: FormBuilder,
    private excelGeneratorService: ExcelGeneratorService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private readonly auditLogViewerService: AuditLogViewerService
  ) {
    this.form = this.fb.group({
      companyId: [],
      routeGroupId: [],
      routeId: [],
      routeAreaId: [],
      assignedUserId: [],
      searchAssignedUser: [],
      salesOfficeId: [],
      functionCodes: []
    });
  }

  ngOnInit(): void {
    // Leer query params de la URL para búsqueda
    this.queryParamsSubscription = this.activatedRoute.queryParams.subscribe((params) => {
      // Leer query param para filtrar por códigos de subruta
      if (params["filterSubRouteCodes"]) {
        const codesParam = params["filterSubRouteCodes"];
        // Parse comma-separated codes (e.g., "0007200047,0007200048")
        this.subRoutesCodesToFilter = codesParam.split(',').map((code: string) => code.trim()).filter((code: string) => code.length > 0);
      }
    });
  }

  ngAfterViewInit(): void {
    // Setup inicial
    this.setupPaginationAndSorting();
    // inicializado
    this.isInitialized = true;
    //activar búsqueda y filtros
    this.onHandleSearch();
    this.setupFilterSubscriptions();
    // primera carga de datos
    this.findAllWithCount();
  }

  private ensureFilterDataLoaded(): void {
    this.fetchAllCompanies();
    this.fetchRouteGroup();
    this.loadPlants();
    this.fetchAllRoute();
    this.fetchRouteArea();
    this.fetchAllUserMaster();
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }



  openRoutesModal(): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_TRIPS.VIEW, "No tienes permisos para ver los viajes de la ruta.")) {
      return;
    }

    this.dialogRefRoutes = this.dialog.open(this.viewRoutesModal, {
      disableClose: true,
      width: '1200px',
      maxHeight: '800px'
    });
    this.dialogRefRoutes.afterClosed().subscribe((result) => {
      result
    });
  }

  private fetchRoute(): void {
    // const selectedIds = this.routeMultiCtrl.value.map((route: any) => route._id.toString());
    this.routeLoaded$.pipe(take(1)).subscribe(() => {
      const selectedIds = this.routeMultiCtrl.value.map((route: any) =>
        route._id.toString()
      );
      this.subrouteService
        .findToComboBoxByPreventa("08", selectedIds)
        .subscribe((res) => {
          this.subrouteList = res.data;
          this.filteredRoute.next(this.subrouteList);

          this.filteredRoute.pipe(take(1)).subscribe((routes) => {
            const selectedMaterial: any = routes.find(
              (route) =>
                route._id.toString() ===
                this.currentUpdateSubRoute?.delSubRouteToEventualCustomer?._id?.toString()
            );
            this.subrouteMultiCtrl.setValue(selectedMaterial?._id.toString());
          });
          // listen for search field value changes
          this.subrouteMultiFilterCtrl.valueChanges
            .pipe(
              skip(1),
              debounceTime(300),
              takeUntil(this._onDestroy)
            )
            .subscribe(() => {
              if (!this.isInitialized) return;
              this.filterRoute();
            });
        });
    });
  }
  private setupFilterSubscriptions(): void {
    // Suscripciones a filtros del formulario
    const filterControls = [
      'companyId',
      'routeGroupId',
      'routeId',
      'routeAreaId',
      'assignedUserId',
      'salesOfficeId',
      'functionCodes'
    ];

    filterControls.forEach(controlName => {
      this.form.get(controlName)?.valueChanges
        .pipe(
          skip(1),
          debounceTime(500),
          distinctUntilChanged(),
          takeUntil(this._onDestroy)
        )
        .subscribe(() => {
          if (!this.isInitialized) return;
          this.pageIndex = 1;//resetear a la pagina 1
          this.findAllWithCount();
        });
    });

    // FormControl separado: masterUserMultiCtrl
    this.masterUserMultiCtrl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        if (!this.isInitialized) return;
        this.pageIndex = 1;//Resetear a la pagina 1
        this.findAllWithCount();
      });

    // FormControl separado: routeGroupMultiCtrl
    this.routeGroupMultiCtrl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        if (!this.isInitialized) return;
        this.pageIndex = 1;
        this.findAllWithCount();
      });
  }

  protected filterRoute() {
    if (!this.subrouteList) {
      return;
    }
    // get the search keyword
    let search = this.subrouteMultiFilterCtrl.value;
    if (!search) {
      this.subfilteredRouteCache = this.subrouteList;
      this.filteredRoute.next(this.subrouteList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.subfilteredRouteCache = this.subrouteList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRoute.next(this.subfilteredRouteCache);
  }

  private fetchRouteC(): void {
    // const selectedIds = this.routeMultiCtrl.value.map((route: any) => route._id.toString());
    this.routeLoaded$.pipe(take(1)).subscribe(() => {
      const selectedIds = this.routeMultiCtrl.value.map((route: any) =>
        route._id.toString()
      );
      this.subrouteService
        .findToComboBoxByPreventa("08", selectedIds)
        .subscribe((res) => {
          this.subrouteCList = res.data;
          this.filteredCRoute.next(this.subrouteCList);

          this.filteredCRoute.pipe(take(1)).subscribe((routes) => {
            const selectedMaterial: any = routes.find(
              (route) =>
                route._id.toString() ===
                this.currentUpdateSubRoute?.delSubRouteToFinalConsumer?._id?.toString()
            );
            this.subrouteCMultiCtrl.setValue(selectedMaterial?._id.toString());
          });
          // listen for search field value changes
          this.subrouteCMultiFilterCtrl.valueChanges
            .pipe(
              skip(1),
              debounceTime(300),
              takeUntil(this._onDestroy)
            )
            .subscribe(() => {
              if (!this.isInitialized) return;
              this.filterRouteC();
            });
        });
    });
  }

  protected filterRouteC() {
    if (!this.subrouteCList) {
      return;
    }
    // get the search keyword
    let search = this.subrouteCMultiFilterCtrl.value;
    if (!search) {
      this.subfilteredCRouteCache = this.subrouteCList;
      this.filteredCRoute.next(this.subrouteCList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.subfilteredCRouteCache = this.subrouteCList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredCRoute.next(this.subfilteredCRouteCache);
  }

  changueOptionsUser(event) {
    let search = event;
    if (!search) {
      this.userMasterList = this.userMasterFilterList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.userMasterList = this.userMasterFilterList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  protected filterRouteMulti() {
    if (!this.routeList) {
      return;
    }
    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = this.routeList;
      this.filteredRoutes.next(this.routeList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRouteCache = this.routeList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRoutes.next(this.filteredRouteCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredRoutes
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.routeMultiCtrl.patchValue(val);
        } else {
          this.routeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.routeMultiCtrl && this.routeMultiCtrl.value) {
      this.filteredRouteCache.forEach((el) => {
        if (this.routeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredRouteCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredRouteCache.length;
    }
  }

  protected filterRoutereAreaMulti() {
    if (!this.routeAreaList) {
      return;
    }
    // get the search keyword
    let search = this.routeAreaMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteAreaCache = this.routeAreaList;
      this.filteredRouteAreas.next(this.routeAreaList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRouteAreaCache = this.routeAreaList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRouteAreas.next(this.filteredRouteAreaCache);
  }

  toggleSelectAllRouteArea(selectAllValue: boolean) {
    this.filteredRouteAreas
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.routeAreaMultiCtrl.patchValue(val);
        } else {
          this.routeAreaMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateRouteArea() {
    let filteredLength = 0;
    if (this.routeAreaMultiCtrl && this.routeAreaMultiCtrl.value) {
      this.filteredRouteAreaCache.forEach((el) => {
        if (this.routeAreaMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 &&
        filteredLength < this.filteredRouteAreaCache.length;
      this.isChecked =
        filteredLength > 0 &&
        filteredLength === this.filteredRouteAreaCache.length;
    }
  }

  private fetchRouteArea(): void {
    // if (this.routeAreasLoaded) return;
    // this.routeAreasLoaded = true;
    this.routeAreasService.findToComboBox().subscribe({
      next: (res) => {
        this.routeAreaList = res.data;
        this.filteredRouteAreas.next(this.routeAreaList);

        this.filteredRouteAreas.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateSubRoute?.routeAreas
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.routeAreaMultiCtrl.setValue(selectedMaterials);
        });

        // listen for search field value changes
        this.routeAreaMultiFilterCtrl.valueChanges
          .pipe(
            skip(1),
            debounceTime(300),
            takeUntil(this._onDestroy)
          )
          .subscribe(() => {
            if (!this.isInitialized) return;
            this.filterRoutereAreaMulti();
            this.setToggleAllCheckboxStateRouteArea();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener area de rutas.", "Cerrar", { duration: 5000 });
      },
    });

    // listen for search field value changes
    this.routeAreaMultiFilterCtrl.valueChanges
      .pipe(
        skip(1),
        debounceTime(300),
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        if (!this.isInitialized) return;
        this.filterRoutereAreaMulti();
        this.setToggleAllCheckboxStateRouteArea();
      });
  }

  private fetchRouteGroup(): void {
    if (this.routeGroupsLoaded) return;
    this.routeGroupsLoaded = true;
    this.routeGroupsService.findToComboBox().subscribe((res) => {
      this.routeGroupList = res.data;
      this.filteredRouteGroup.next(this.routeGroupList);

      // listen for search field value changes
      // listen for search field value changes
      this.routeGroupMultiFilterCtrl.valueChanges
        .pipe(
          skip(1),
          debounceTime(300),
          takeUntil(this._onDestroy)
        )
        .subscribe(() => {
          if (!this.isInitialized) return;
          this.filterRouteGroupMulti();
        });
    });
  }

  protected filterRouteGroupMulti() {
    if (!this.routeGroupList) {
      return;
    }
    // get the search keyword
    let search = this.routeGroupMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteGroupCache = this.routeGroupList;
      this.filteredRouteGroup.next(this.routeGroupList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRouteGroupCache = this.routeGroupList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRouteGroup.next(this.filteredRouteGroupCache);
  }

  toggleFirstPanel(expanded: boolean) {
    this.isFirstPanelExpanded = expanded;
  }

  getConnectedDropLists(): string[] {
    const connectedIds = this.filteredData.data.map(
      (element) => `table-${element._id}`
    );
    return connectedIds;
  }

  drop(event: CdkDragDrop<any[]>, elementId: string) {
    let transferredElement;
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      if (event.container.id.split("-")[1]) {
        this.updateFrequencyPosition(event);
      }
    } else {
      let frequencyId = event.container.id.split("-")[1];
      transferredElement = event.previousContainer.data[event.previousIndex];
      const alreadyExists = event.container.data.some(
        (item) => item._id === transferredElement._id
      );

      if (!frequencyId) {
        let frequencyId = event.previousContainer.id.split("-")[1];
        this.deleteFrequencyBusinessPartner(transferredElement, frequencyId);
      } else {
        this.updateFrequencyBusinessPartner(transferredElement, frequencyId);
      }

      if (!alreadyExists) {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
    }

    const mainTable = this.mainTables.toArray().find((table) => {
      const tableId = table["_elementRef"].nativeElement.getAttribute("id");
      return tableId === `table-${elementId}`;
    });

    if (mainTable) {
      mainTable.renderRows();
    } else {
      const elementId = event.previousContainer.id.split("-")[1];
      this.tables[elementId].table.renderRows();
      this.table.renderRows();
    }
  }

  registerTable(elementId: string, table: MatTable<any>) {
    this.tables[elementId] = { id: elementId, table: table };
  }

  initResize(event: MouseEvent) {
    event.preventDefault();
    this.initialWidth = this.additionalContentWidth; // Ancho actual
    this.startX = event.clientX; // Posición inicial
    window.addEventListener("mousemove", this.resize);
    window.addEventListener("mouseup", this.stopResize);
  }

  // Redimensionar el div
  resize = (event: MouseEvent) => {
    const newWidth = this.initialWidth - (event.clientX - this.startX); // Calcular nuevo ancho
    if (newWidth > this.additionalContentWidth) {
      this.resizeIcon = "heroicons_outline:chevron-double-left";
    } else {
      this.resizeIcon = "heroicons_outline:chevron-double-right";
    }

    if (newWidth > 100) {
      // Limitar el ancho mínimo
      this.additionalContentWidth = newWidth; // Actualiza el ancho
    }

    if (newWidth > 695) {
      this.isSmallScreen = true;
    } else {
      this.isSmallScreen = false;
    }
  };

  // Detener el redimensionamiento
  stopResize = () => {
    window.removeEventListener("mousemove", this.resize);
    window.removeEventListener("mouseup", this.stopResize);
  };

  toggleExpand(element: any) {
    if (this.expandedElement === element) {
      this.expandedElement = null;
      this.businessPartenerFrequencyList = [];
    } else {
      this.expandedElement = element;
      this.fetchBusinessbyFrequency(element);
      const mainTable = this.mainTables.toArray().find((table) => {
        const tableId = table["_elementRef"].nativeElement.getAttribute("id");
        return tableId === `table-${element._id}`;
      });
      this.registerTable(element._id, mainTable);
    }
  }

  toggleSecondDiv() {
    this.isSecondDivVisible = !this.isSecondDivVisible;
  }

  groupDataByFrequencyType(data?: any) {
    const defaultCategories = ["W", "Q", "M"];
    const grouped = defaultCategories.reduce((acc, category) => {
      acc[category] = { frequencies: [] };
      return acc;
    }, {});

    if (data && data.filteredData) {
      data.filteredData.forEach((frequency) => {
        const frequencyType = frequency.type;
        if (!grouped[frequencyType]) {
          grouped[frequencyType] = { frequencies: [] };
        }
        grouped[frequencyType].frequencies.push(frequency);
      });
    }
    this.groupedFrequencies = grouped;
  }

  updateFilteredData(newData) {
    this.filteredData = newData;
    this.groupDataByFrequencyType(newData);
  }

  private fetchallBusinessPartner(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortFieldBP();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    this.businessPartnerService
      .findAllWithCountBySubRoute(
        {
          currentPage: this.pageIndex,
          limitPerPage: this.pageSizebp,
          search: this.searchQuerybp,
          sort: sortField,
          sortDirection: sortDirection,
        },
        this.currentUpdateSubRoute._id.toString(),
        true
      )
      .subscribe((data) => {
        this.clientsData = data?.data.data;

        if (this.filterAssigned == 1) {
          // Filtrar solo los asignados
          this.clientsData = this.clientsData.filter(
            (client) => client.frequenciesFromThisSubRoute.length > 0
          );
        } else if (this.filterAssigned == 0) {
          // Filtrar solo los no asignados
          this.clientsData = this.clientsData.filter(
            (client) => client.frequenciesFromThisSubRoute.length === 0
          );
        } else {
          // Mostrar todos los clientes
          this.clientsData = this.clientsData;
        }

        // this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        // this.paginator.length = this.totalItems;
      });
  }

  private getFilterBusinessTypes(): void {
    this.businessTypeService.findToComboBox("1").subscribe({
      next: (res) => {
        this.businessPartnerFilterTypeList = res.data;
        this.getBusinessPartner();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener tipo de socios de negocios.", "Cerrar", { duration: 5000 });
      },
    });
  }

  getBusinessPartner(): void {
    let typeCodes = this.businessPartnerFilterTypeList.map((e) => e.code);

    this.businessService.findToComboBox(typeCodes).subscribe((data) => {
      this.businessPartnerRespList = data?.data ?? [];
    });
  }

  private async fetchAllUserMaster(): Promise<void> {
    if (this.userMastersLoaded) return;
    this.userMastersLoaded = true;
    try {
      /* Al Editar cargo esta lista con todos los colaboradores */
      const resUser: any = await firstValueFrom(
        this.userMasterService.findToComboBox()
      );
      this.userMasterList = resUser.data;
      this.userMasterFilterList = resUser.data.slice();

      const filteredUsers = [];
      const res: any = await firstValueFrom(
        this.userMasterService.findToComboBox()
      );

      let userIds = [];

      for (let user of res.data) {
        userIds.push(user.masterUserId.toString());
      }

      const assignedResults = await this.checkIfUserAssignedToRoute(userIds);

      for (let i = 0; i < assignedResults.length; i++) {
        if (!assignedResults[i]) {
          filteredUsers.push(res.data[i]); // Agrega el objeto completo de user
        }
      }
      this.mainCollabList = filteredUsers;
    } catch (err) {
      this.snackBar.open(err.error.message || "Error al obtener usuarios maestros.", "Cerrar", { duration: 5000 });
    }
  }

  onMainCollabChange(event: any) {
    let selectedItem: MainCollabItem | undefined;
    selectedItem = event as MainCollabItem;
    this.noPartnerAssigned =
      !!selectedItem && !selectedItem.businessPartnerName;
    if (this.noPartnerAssigned) {
      this.snackBar.open("El usuario aún no tiene socio asignado", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
    }
  }

  private async checkIfUserAssignedToRoute(
    userIds: string[]
  ): Promise<boolean[]> {
    try {
      const res = await firstValueFrom(
        this.subrouteService.findToMainCollaborator(userIds)
      );
      return userIds.map((userId) =>
        res.data.some(
          (user) => user.mainCollaborator.masterUserId.toString() === userId
        )
      );
    } catch (err) {
      this.snackBar.open(err.error.message || "Error al marcar si el usuario es asignado.", "Cerrar", { duration: 5000 });
      return userIds.map(() => false);
    }
  }

  private fetchBusinessbyFrequency(expanded: any): void {
    this.frequencybpService
      .findClientByFrequency(
        this.currentUpdateSubRoute._id.toString(),
        expanded._id.toString()
      )
      .subscribe({
        next: (res) => {
          this.businessPartenerFrequencyList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener socio de negocio por frecuencia.", "Cerrar", { duration: 5000 });
        },
      });
  }

  private fetchAllBusinessTypes(): void {
    this.businessFunctionService.findToComboBox().subscribe({
      next: (res) => {
        this.businessPartnerFunctionList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener funciónes de socios de negocios.", "Cerrar", { duration: 5000 });
      },
    });
  }

  private initializeCreateFrequency(): ICreateSubRouteFrequency {
    return {
      days: [],
      businessPartners: [
        {
          businessPartnerId: "",
        },
      ],
    };
  }
  private initializeCreateSubRoute(): ICreateSubRoute {
    return {
      // code:"",
      warehouseIds: [],
      model: "",
      name: "",
      companyId: "",
      salesOfficeId: "",
      routeIds: [],
      plantId: "",
      routeGroupId: "",
      routeAreaIds: [],
      deliverySubRouteId: "",
      type: "",
      subRouteFunctionId: "",
      mainCollaborator: {
        masterUserId: null,
      },
      responsibleBusinessPartnerId: null,
      vehicleId: null,
      useGps: true,
      useGpsMode: PermissionModeEnum.PERMISSIVE,
      distanceBtwSellerAndCustomer: 0,
      forceCloseTripPastEndDate: ForceCloseTripEnum.FORCE,
      allowManualBonus: false,
      invoicedDeliveryCollectionBehaviour: InvoicedDeliveryCollectionBehaviourEnum.NEVER_ASK,
      deliveryAssignmentStrategy: DeliveryAssignmentStrategyEnum.AUTO_NOT_EDITABLE,
      commercialConditionMode: CommercialCondModeEnum.SHIP_TO_ONLY
    };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  private fetchAllCompanies(): void {
    if (this.companiesLoaded) return;
    this.companiesLoaded = true;
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.", "Cerrar", { duration: 5000 });
      },
    });
  }

  private fetchAllWarehouses(): void {
    this.warehouseService.findToComboBox().subscribe({
      next: (res) => {
        this.warehouseList = res.data;
        this.filteredWarehouses.next(this.warehouseList);

        this.filteredWarehouses.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateSubRoute?.warehouses
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.warehouseMultiCtrl.setValue(selectedMaterials);
        });

        // listen for search field value changes
        this.warehouseMultiFilterCtrl.valueChanges
          .pipe(
            skip(1),
            debounceTime(300),
            takeUntil(this._onDestroy)
          )
          .subscribe(() => {
            if (!this.isInitialized) return;
            this.filterWarehouseMulti();
            this.setToggleAllCheckboxStateWarehouse();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener almacenes.", "Cerrar", { duration: 5000 });
      },
    });
  }

  protected filterWarehouseMulti() {
    if (!this.warehouseList) {
      return;
    }
    // get the search keyword
    let search = this.warehouseMultiFilterCtrl.value;
    if (!search) {
      this.filteredWarehouseCache = this.warehouseList;
      this.filteredWarehouses.next(this.warehouseList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredWarehouseCache = this.warehouseList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      const plantMatches =
        material.plants &&
        material.plants.some((p) => p.name.toLowerCase().indexOf(search) > -1);
      return nameMatches || codeMatches || plantMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredWarehouses.next(this.filteredWarehouseCache);
  }

  toggleSelectAllWarehouse(selectAllValue: boolean) {
    this.filteredWarehouses
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.warehouseMultiCtrl.patchValue(val);
        } else {
          this.warehouseMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateWarehouse() {
    let filteredLength = 0;
    if (this.warehouseMultiCtrl && this.warehouseMultiCtrl.value) {
      this.filteredWarehouseCache.forEach((el) => {
        if (this.warehouseMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 &&
        filteredLength < this.filteredWarehouseCache.length;
      this.isChecked =
        filteredLength > 0 &&
        filteredLength === this.filteredWarehouseCache.length;
    }
  }
  private fetchAllSubRouteFunction(): void {
    this.functionService.findToComboBox().subscribe({
      next: (res) => {
        this.functionList = res.data;
        const sFunction = this.currentUpdateSubRoute?.function;
        if (sFunction) {
          this.onSelectNewSubRouteFunction(String(sFunction._id));
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener funciones.", "Cerrar", { duration: 5000 });
      },
    });
  }

  private onSelectNewSubRouteFunction(subRouteFunctionId: string): void {
    this.subRouteFunctionSelected = null;
    const subRouteFunctionFound = this.functionList.find(
      (f) => String(f._id) == String(subRouteFunctionId)
    );
    if (subRouteFunctionFound) {
      this.subRouteFunctionSelected = subRouteFunctionFound;
    }
  }

  private fetchAllVehicle(): void {
    const excludeSubRouteId = this.currentUpdateSubRoute?._id?.toString() ?? null;
    this.vehicleService.findToComboBoxFilter(excludeSubRouteId).subscribe({
      next: (res) => {
        this.vehicleList = res.data;
        this.filteredVehicles.next(this.vehicleList);

        const currentVehicle = this.currentUpdateSubRoute?.vehicle;
        const selectedVehicle = currentVehicle
          ? this.vehicleList.find(
              (vehicle) => vehicle._id.toString() === currentVehicle._id.toString()
            ) ?? currentVehicle
          : null;
        this.vehicleCtrl.setValue(selectedVehicle, { emitEvent: false });

        // listen for search field value changes
        this.vehicleFilterCtrl.valueChanges
          .pipe(skip(1), debounceTime(300), takeUntil(this._onDestroy))
          .subscribe(() => this.filterVehicles());
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener vehículos.", "Cerrar", { duration: 5000 });
      },
    });
  }

  protected filterVehicles(): void {
    if (!this.vehicleList) {
      return;
    }
    let search = this.vehicleFilterCtrl.value;
    if (!search) {
      this.filteredVehicles.next(this.vehicleList);
      return;
    }
    search = search.toLowerCase();
    const filtered = this.vehicleList.filter((vehicle) => {
      const nameMatches = vehicle.name?.toLowerCase().indexOf(search) > -1;
      const codeMatches = getCode(vehicle)?.toLowerCase().indexOf(search) > -1;
      const plateMatches = vehicle.plate?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches || plateMatches;
    });
    this.filteredVehicles.next(filtered);
  }

  private fetchAllSubRutas(): void {
    this.subrouteService.findToComboBox().subscribe({
      next: (res) => {
        this.subRutaList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener rutas.", "Cerrar", { duration: 5000 });
      },
    });
  }


  private fetchAllRoute(): void {
    // if (this.routesLoaded) return;
    // this.routesLoaded = true;
    this.routeService.findToComboBox().subscribe({
      next: (res) => {
        this.routeList = res.data;
        this.filteredRoutes.next(this.routeList);

        this.filteredRoutes.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateSubRoute?.routes
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.routeMultiCtrl.setValue(selectedMaterials);
        });
        this.routeLoaded$.next(); //
        // listen for search field value changes
        // listen for search field value changes
        this.routeMultiFilterCtrl.valueChanges
          .pipe(
            skip(1),
            debounceTime(300),
            takeUntil(this._onDestroy)
          )
          .subscribe(() => {
            if (!this.isInitialized) return;
            this.filterRouteMulti();
            this.setToggleAllCheckboxState();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener territorios.", "Cerrar", { duration: 5000 });
      },
    });
  }

  private fetchAllSalesOffice(): void {
    this.salesOfficeService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener oficinas de venta.", "Cerrar", { duration: 5000 });
      },
    });
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
    const search = this.searchService.searchTermSync;
    const hasSearch = search && search.trim().length > 0;

    // Check if we need to filter by codes from query params (PRIORITY FILTER)
    let filter: IFilters;

    if (this.subRoutesCodesToFilter.length > 0) {
      // ONLY filter by codes, ignore all other filters
      filter = {
        subRouteCodes: this.subRoutesCodesToFilter
      };
    } else {
      // Normal filtering logic
      filter = {
        companyId: this.form.get("companyId").value,
        routeGroupId: this.form.get("routeGroupId").value,
        routeId: this.form.get("routeId").value,
        routeAreaId: this.form.get("routeAreaId").value,
        seller: this.form.get("assignedUserId").value,
        status: this.selectedStatuses,
        salesOfficeId: this.form.get("salesOfficeId").value,
        functionCodes: this.form.get("functionCodes").value
      };
    }

    this.subrouteService
      .findAllWithCount(
        {
          currentPage: hasSearch ? 1 : this.pageIndex, //Resetea a la página 1
          limitPerPage: this.pageSize,
          search,
          sort: sortField,
          sortDirection: sortDirection,
        },
        filter,
        this.masterUserMultiCtrl.value,
        // this.routeMultiCtrl.value,
        // this.routeAreaMultiCtrl.value,
        // this.routeGroupMultiCtrl.value,
        this.modeTree
      )
      .subscribe((data) => {
        this.auxData = [];
        this.auxDataSalesOffice = [];
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        if (this.paginator) {
          this.paginator.length = this.totalItems;
        }

        // Clear the codes filter after first load (one-time filter from query params)
        if (this.subRoutesCodesToFilter.length > 0) {
          this.subRoutesCodesToFilter = [];
        }

        // const tempTreeSalesOffice = this.buildTreeBySalesOffice(this.dataSource);
        // this.dataSourceTree.data = tempTreeSalesOffice;

        // // Tree
        // let tempTree = [];
        // const uniqueSubRouteByTerritory: SubRouteWithTerritoryAUx[] = [];
        // const seenTerritoryIds = new Set<number>();

        // // Separo por distinto territorio
        // for (const item of data?.data?.[0]?.data ?? []) {
        //   const subRouteByTerritory: SubRouteWithTerritoryAUx = { ...item };
        //   for (const route of subRouteByTerritory.routes) {
        //     if (!seenTerritoryIds.has(route.id)) {
        //       seenTerritoryIds.add(route.id);
        //       subRouteByTerritory.auxUniqueTerritory = { ...route };
        //       uniqueSubRouteByTerritory.push({ ...subRouteByTerritory });
        //     }

        //     //Data separated by route
        //     subRouteByTerritory.auxUniqueTerritory = { ...route };
        //     this.auxData.push(subRouteByTerritory);
        //   }
        // }

        // let principals = uniqueSubRouteByTerritory;
        // for (const ep of principals) {
        //   let node = {
        //     ...ep,
        //     children: [],
        //   };

        //   this.getTree(node, node.auxUniqueTerritory.id);
        //   tempTree.push(node);
        // }

        // this.dataSourceTree.data = tempTree;
      });
  }

  onChangeEmissionPointTree(element) {
    this.modeTree = element;
    if (this.modeTree === "salesOffice") {
      this.findAllWithCount();
      this.dataSourceTree.data = this.buildTreeBySalesOffice(this.dataSource);
    } else if (this.modeTree === "territory") {
      this.findAllWithCount();
      this.dataSourceTree.data = this.buildTreeByTerritory(this.dataSource);
    } else if (this.modeTree === "group") {
      this.findAllWithCount();
      this.dataSourceTree.data = this.buildTreeByRouteGroup(this.dataSource);
    } else {
      this.findAllWithCount();
    }
  }

  // selectMode(value: "territory" | "salesOffice" | "group" | null) {
  //   this.selectedMode = value;
  //   this.modeTree = value;
  //   this.onChangeEmissionPointTree(); // tu lógica para reconstruir la tabla
  // }

  getGroupName(subRoute: any): string {
    if (this.modeTree === "salesOffice")
      return subRoute.auxUniqueSalesOffice?.name ?? "-";
    if (this.modeTree === "territory")
      return subRoute.auxUniqueTerritory?.name ?? "-";
    if (this.modeTree === "group")
      return subRoute.auxUniqueRouteGroup?.name ?? "-";
    return "-";
  }

  getTooltip(subRoute: any): string | null {
    if (this.modeTree === "territory" && subRoute.routes?.length > 1) {
      return this.getRouteNames(subRoute.routes);
    }
    return null;
  }

  getTree(data: SubRouteNode, routeId: number) {
    let auxData = this.dataSource.slice();

    data.children = [];
    auxData.forEach((res) => {
      /*if(res.auxUniqueTerritory.id == routeId){
        data.children.push({
          ...res
        })
      }*/
      res.routes.forEach((r) => {
        if (r.id == routeId) {
          data.children.push({
            ...res,
            auxUniqueTerritory: r,
          });
        }
      });
    });
  }

  // Construye árbol agrupado por TERRITORIO
  private buildTreeByTerritory(data: any[]): any[] {
    let tempTree: SubRouteNode[] = [];
    const uniqueSubRouteByTerritory: SubRouteWithTerritoryAUx[] = [];
    const seenTerritoryIds = new Set<String>();

    for (const item of data ?? []) {
      const subRouteByTerritory: SubRouteWithTerritoryAUx = { ...item };

      if (subRouteByTerritory.routes?.length > 0) {
        for (const territory of subRouteByTerritory.routes) {
          if (!seenTerritoryIds.has(territory._id.toString())) {
            seenTerritoryIds.add(territory._id.toString());
            subRouteByTerritory.auxUniqueTerritory = { ...territory };
            uniqueSubRouteByTerritory.push({ ...subRouteByTerritory });
          }

          // Guardar por cada territorio
          subRouteByTerritory.auxUniqueTerritory = { ...territory };
          this.auxData.push(subRouteByTerritory);
        }
      }
    }

    for (const ep of uniqueSubRouteByTerritory) {
      let node = {
        ...ep,
        children: [],
      };

      this.getTree(node, node.auxUniqueTerritory.id);
      tempTree.push(node);
    }
    return tempTree;
  }

  private buildTreeBySalesOffice(items: any[]): any[] {
    const tempTree: SubRouteNode[] = [];
    const uniqueSubRouteBySalesOffice: SubRouteWithSalesOfficeAUx[] = [];
    const seenSalesOfficeIds = new Set<String>();

    // reset auxData local/prop
    this.auxDataSalesOffice = [];
    for (const item of items ?? []) {
      const subRouteBySalesOffice: SubRouteWithSalesOfficeAUx = { ...item };

      if (subRouteBySalesOffice.salesOffice) {
        const office = subRouteBySalesOffice.salesOffice;

        if (!seenSalesOfficeIds.has(office._id.toString())) {
          seenSalesOfficeIds.add(office._id.toString());
          subRouteBySalesOffice.auxUniqueSalesOffice = { ...office };
          uniqueSubRouteBySalesOffice.push({ ...subRouteBySalesOffice });
        }

        // Guardar por cada oficina (para luego construir children)
        subRouteBySalesOffice.auxUniqueSalesOffice = { ...office };
        this.auxDataSalesOffice.push(subRouteBySalesOffice);
      }
    }

    // Construcción del árbol por oficina de venta
    for (const ep of uniqueSubRouteBySalesOffice) {
      const node: SubRouteNode = {
        ...ep,
        children: [],
      };

      this.getTreeBySalesOffice(node, node.auxUniqueSalesOffice._id.toString());
      tempTree.push(node);
    }

    return tempTree;
  }

  private buildTreeByRouteGroup(items: any[]): any[] {
    const tempTree: SubRouteNode[] = [];
    const uniqueSubRouteByRouteGroup: SubRouteWithRouteGroupAux[] = [];
    const seenRouteGroupIds = new Set<String>();

    // reset auxData local/prop
    this.auxDataRouteGroup = [];

    for (const item of items ?? []) {
      const subRouteByRouteGroup: SubRouteWithRouteGroupAux = { ...item };

      if (subRouteByRouteGroup.routeGroup) {
        const group = subRouteByRouteGroup.routeGroup;

        if (!seenRouteGroupIds.has(group._id.toString())) {
          seenRouteGroupIds.add(group._id.toString());
          subRouteByRouteGroup.auxUniqueRouteGroup = { ...group };
          uniqueSubRouteByRouteGroup.push({ ...subRouteByRouteGroup });
        }

        // Guardar por cada grupo (para luego construir children)
        subRouteByRouteGroup.auxUniqueRouteGroup = { ...group };
        this.auxDataRouteGroup.push(subRouteByRouteGroup);
      }
    }

    // Construcción del árbol por grupo de ruta
    for (const ep of uniqueSubRouteByRouteGroup) {
      const node: SubRouteNode = {
        ...ep,
        children: [],
      };

      this.getTreeByRouteGroup(node, node.auxUniqueRouteGroup._id.toString());
      tempTree.push(node);
    }

    return tempTree;
  }

  getTreeByRouteGroup(data: SubRouteNode, routeGroupId: string) {
    let auxData = this.dataSource.slice();

    data.children = [];
    auxData.forEach((res) => {
      if (res.routeGroup && res.routeGroup._id.toString() === routeGroupId) {
        data.children.push({
          ...res,
          auxUniqueRouteGroup: res.routeGroup,
        });
      }
    });
  }

  getTreeBySalesOffice(data: SubRouteNode, salesOfficeId: string) {
    let auxData = this.dataSource.slice();

    data.children = [];
    auxData.forEach((res) => {
      if (res.salesOffice && res.salesOffice._id.toString() === salesOfficeId) {
        data.children.push({
          ...res,
          auxUniqueSalesOffice: res.salesOffice,
        });
      }
    });
  }

  private getSortField(): keyof SubRouteAttributes {
    const validSortFields: (keyof SubRouteAttributes)[] = ["id", "name"];
    return validSortFields.includes(
      this.sort.active as keyof SubRouteAttributes
    )
      ? (this.sort.active as keyof SubRouteAttributes)
      : "id";
  }

  private getSortFieldBP(): keyof BusinessPartnerAttributes {
    const validSortFields: (keyof BusinessPartnerAttributes)[] = [
      "id",
      "name",
      "creditLimit",
      "position",
    ];
    return validSortFields.includes(
      this.sort.active as keyof BusinessPartnerAttributes
    )
      ? (this.sort.active as keyof BusinessPartnerAttributes)
      : "id";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchService.setSearchTerm(input.value);
  }

  onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .pipe(
        skip(1),
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((term) => {
        if (!this.isInitialized) return;

        if (term.length >= 2 || term.length === 0) {
          this.findAllWithCount();
        }
      });
  }

  onSearchChangeFrequency() {
    // Filtra las frecuencias basado en el nombre de los businessPartners
    const filteredFrequencies = this.currentUpdateSubRoute.frequency.filter(
      (frequency) =>
        frequency.businessPartners.some((b) =>
          b.businessPartner.name
            .toLowerCase()
            .includes(this.filterValue.toLowerCase())
        )
    );

    // Agrupa las frecuencias filtradas
    this.groupDataByFrequencyType({ filteredData: filteredFrequencies });
  }

  onFilterChange(event: MatCheckboxChange): void {
    this.fetchallBusinessPartner(); // Vuelve a llamar al método para aplicar el filtro
  }

  onSearchChangeBP(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuerybp = input.value.trim();
    if (this.searchQuerybp.length >= 2 || this.searchQuerybp.length === 0) {
      // this.paginator.pageIndex = 0;
      this.fetchallBusinessPartner();
    }
  }

  trackByFn(index: number, item: SubRouteAttributes): string {
    return item._id.toString();
  }

  createCollaborator(result): void {
    this.subRouteCollaboratorService
      .createEmbedded(this.currentUpdateSubRoute._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.subRouteCollaboratorService
            .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
            .subscribe((data) => {
              this.currentUpdateSubRoute.collaborators = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  updateCollaborator(result): void {
    this.subRouteCollaboratorService
      .updateEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.subRouteCollaboratorService
            .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
            .subscribe((data) => {
              this.currentUpdateSubRoute.collaborators = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }
  openFrecuenciasModal(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.VIEW, "No tienes permisos para ver las frecuencias.")) {
      return;
    }

    this.currentUpdateSubRoute = {
      ...subRoute,
    };
    this.groupedFrequencies = {
      W: { frequencies: [] },
      Q: { frequencies: [] },
      M: { frequencies: [] },
    };

    this.filteredData = new MatTableDataSource(
      this.currentUpdateSubRoute.frequency
    );
    this.fetchallBusinessPartner();
    this.groupDataByFrequencyType(this.filteredData);
    this.dialog
      .open(this.addModalFrequency, {
        panelClass: "form-modal-frequency",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
        }
      });
  }

  //! DEPRECATED
  openItineraryModal(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY.VIEW, "No tienes permisos para ver el itinerario.")) {
      return;
    }

    this.actionsItinerary = Object.values(ItineraryActionEnum);
    this.currentUpdateSubRoute = {
      ...subRoute,
    };
    this.getListItinerary();
    this.getListAlternativeItinerary();
    this.dialog
      .open(this.addModalItinerary, {
        //panelClass: "form-modal",
        width: "90%",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
        }
      });
  }

  openRoutingItineraryModal(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY.VIEW, "No tienes permisos para ver el itinerario.")) {
      return;
    }

    this.actionsItinerary = Object.values(ItineraryActionEnum);
    this.currentUpdateSubRoute = {
      ...subRoute,
    };
    this.subRouteItineraryList = [];
    this.subRouteAlternativeItineraryList = [];
    this.getRoutingItineraryByType("SUB_ROUTE");
    this.getRoutingItineraryByType("SUB_ROUTE_ALTERNATIVE");
    this.dialog
      .open(this.routingItineraryModal, {
        width: "50%",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
        }
      });
  }

  openOrderModal(subRoute: SubRouteAttributes): void {
    this.currentUpdateSubRoute = {
      ...subRoute,
    };
    this.dialog
      .open(this.addModalOrder, {
        panelClass: "form-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
        }
      });
  }

  openAddOrderModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerOrderComponent, {
      panelClass: ".form-modal-interlocutor",
      data: existingData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateOrder(result);
        } else {
          this.createOrder(result);
        }
      }
    });
  }

  createOrder(result): void {
    this.subRouteOrderService
      .createEmbedded(this.currentUpdateSubRoute._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Horario creado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.subRouteOrderService
            .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
            .subscribe((data) => {
              this.currentUpdateSubRoute.orderDeliveryWindows = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el horario",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  updateOrder(result): void {
    this.subRouteOrderService
      .updateEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Horario actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.subRouteOrderService
            .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
            .subscribe((data) => {
              this.currentUpdateSubRoute.orderDeliveryWindows = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el horario",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  private initializeCreateSubRouteItinerary(): ICreateSubRouteItinerary {
    return {
      days: [],
      action: [],
      datetimeStart: new Date(),
      datetimeEnd: new Date(),
    };
  }

  private initializeCreateSubRouteItineraryV2(): ICreateRoutingItinerary {
    return {
      type: null,
      subRouteId: null,
      dateTimeStart: new Date(),
      dateTimeEnd: new Date(),
      detail: [],
    };
  }

  addItinerary(type) {
    const dialogRef = this.dialog.open(RoutingItinerary, {
      panelClass: ".form-modal-interlocutor",
      data: { type: type, subRouteId: this.currentUpdateSubRoute._id },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (type == 1) {
          this.getRoutingItineraryByType(RoutingItineraryTypesEnum.SUB_ROUTE);
        } else {
          this.getRoutingItineraryByType(
            RoutingItineraryTypesEnum.SUB_ROUTE_ALTERNATIVE
          );
        }
      }
    });
  }

  isValidItineraryActions(): boolean {
    const orderedActions = [
      ItineraryActionEnum.CHARGE,
      ItineraryActionEnum.START_TRIP,
      ItineraryActionEnum.IN_TRIP,
      ItineraryActionEnum.RETURN,
    ];

    // Ordenamos los días
    const sortedDays = this.listItineraryDetail.sort((a, b) => a.day - b.day);

    if (sortedDays.length === 0 || sortedDays[0].action.length === 0) {
      this.snackBar.open("No hay acciones en el primer día.", "Cerrar", { duration: 5000 });
      return false;
    }

    // Detectamos el índice inicial a partir de la primera acción del primer día
    let currentActionIndex = orderedActions.indexOf(sortedDays[0].action[0]);

    if (currentActionIndex === -1) {
      this.snackBar.open(`Acción inicial no válida: ${sortedDays[0].action[0]}`, "Cerrar", { duration: 5000 });
      return false;
    }

    for (const day of sortedDays) {
      for (const action of day.action) {
        if (action !== orderedActions[currentActionIndex]) {
          this.snackBar.open(
            `Error en día ${day.day}: Esperado ${orderedActions[currentActionIndex]}, pero se encontró ${action}`,
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
          return false; // Se rompió el orden
        }
        // Acción correcta, avanzar al siguiente
        currentActionIndex = (currentActionIndex + 1) % orderedActions.length;
      }
    }

    return true;
  }

  createItinerary(result, type: number) {
    if (type === 1) {
      return this.itineraryService.createEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        result
      );
    } else if (type === 2) {
      return this.itineraryAlternativeService.createEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        result
      );
    }
    return null;
  }

  onUpdateItinerary(element, i) {
    element.isEditMode = true;
  }

  onStatusChangeItinerary(event: boolean, element) {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY.UPDATE, "No tienes permisos para cambiar el estado del itinerario.")) {
      return;
    }

    const updatedStatusId = event ? 1 : 0;
    element.statusId = updatedStatusId;
  }

  onSaveItinerary(element, type, index) {
    if (
      element.dateTimeStart == null ||
      element.dateTimeStart == "" ||
      element.dateTimeEnd == null ||
      element.dateTimeEnd == ""
    ) {
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
      return;
    }

    element.isEditMode = false;
    this.updateItinerary(element, type == 1 ? 1 : 2);
  }

  updateItinerary(result, type: number): void {
    if (type === 1) {
      this.routingItineraryService
        .update(result._id.toString(), result)
        .subscribe({
          next: () => {
            this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
              duration: 5000,
              verticalPosition: "top",
            });
            this.getRoutingItineraryByType(RoutingItineraryTypesEnum.SUB_ROUTE);
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar el registro",
              "Cerrar",
              { duration: 5000, verticalPosition: "top" }
            );
          },
        });
    } else if (type === 2) {
      this.routingItineraryService
        .update(result._id.toString(), result)
        .subscribe({
          next: () => {
            this.snackBar.open(
              "Itinerario Alternativo actualizado con éxito",
              "Cerrar",
              { duration: 5000, verticalPosition: "top" }
            );
            this.getRoutingItineraryByType(
              RoutingItineraryTypesEnum.SUB_ROUTE_ALTERNATIVE
            );
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message ||
              "Error al actualizar el itinerario alternativo",
              "Cerrar",
              { duration: 5000, verticalPosition: "top" }
            );
          },
        });
    }
  }

  getDayNames(day: number): string {
    const foundDay = this.daysList.find((d) => d.value === day);
    return foundDay ? foundDay.day : "";
  }

  // Esta función convierte la clave del model enum a su valor
  getModelName(modelValue: string): string {
    switch (modelValue) {
      case SubRouteModelEnum.AUTOVENTA:
        return "Autoventa";
      case SubRouteModelEnum.PREVENTA:
        return "Preventa";
      case SubRouteModelEnum.ENTREGA:
        return "Entrega";
      default:
        return "Sin Modelo";
    }
  }

  // Esta función convierte la clave del model enum a su valor
  getSubRouteTypeName(modelValue: string): string {
    switch (modelValue) {
      case SubRouteTypeEnum.FOREIGN:
        return "Foránea";
      case SubRouteTypeEnum.URBAN:
        return "Urbana";
      default:
        return "Sin Modelo";
    }
  }

  openAddFrecuenciesModal(existingData?) {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.VIEW, "No tienes permisos para ver las frecuencias.")) {
      return;
    }

    const dialogRef = this.dialog.open(AddFrequencies, {
      panelClass: ".form-modal-interlocutor",
      data: existingData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          // this.updateItinerary(result, type);
        } else {
          // this.createItinerary(result, type);
        }
      }
    });
  }

  openAddFrequencyModal(existingData?) {
    const permiso = existingData ? this.PERMISSIONS_FREQUENCIES.UPDATE : this.PERMISSIONS_FREQUENCIES.CREATE;
    if (!this.checkIfHasPermission(permiso, "No tienes permisos para gestionar frecuencias.")) {
      return;
    }

    const dialogRef = this.dialog.open(AddSubRouteFrequency, {
      panelClass: ".form-modal-interlocutor",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateFrequency(result);
        } else {
          this.createFrequency(result);
        }
      }
    });
  }

  createFrequency(result): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.CREATE, "No tienes permisos para crear frecuencias.")) {
      return;
    }

    this.currentCreateFrequency = {
      ...result,
      dates: result.dates ? [result.dates] : [],
      businessPartners: (result.businessPartners || []).map((b, index) => ({
        businessPartnerId: b,
        position: index + 1,
      })),
    };
    this.frequencyService
      .createEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        this.currentCreateFrequency
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.frequencyService
            .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
            .subscribe((data) => {
              this.currentUpdateSubRoute.frequency = data?.data;
              this.filteredData = new MatTableDataSource(data?.data);
              this.groupDataByFrequencyType({ filteredData: data?.data });
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  updateFrequencyBusinessPartner(result, frequencyId: string): void {
    this.frequencybpService
      .createBusinessPartnerF(
        this.currentUpdateSubRoute._id.toString(),
        frequencyId,
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
            panelClass: "snack-bar-success",
          });
          this.frequencybpService
            .findClientByFrequency(
              this.currentUpdateSubRoute._id.toString(),
              result._id.toString()
            )
            .subscribe((data) => {
              this.businessPartenerFrequencyList = data.data;
            });
          this.fetchallBusinessPartner();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  deleteFrequencyBusinessPartner(result, frequencyId: string): void {
    this.frequencybpService
      .deleteBusinessPartnerF(
        this.currentUpdateSubRoute._id.toString(),
        frequencyId,
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.frequencybpService
            .findClientByFrequency(
              this.currentUpdateSubRoute._id.toString(),
              result._id.toString()
            )
            .subscribe((data) => {
              this.businessPartenerFrequencyList = data.data;
            });
          this.fetchallBusinessPartner();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al eliminar el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  updateFrequencyPosition(result): void {
    let businessPartnerPosition: any = {
      businessPartnerId:
        result.container.data[result.currentIndex]._id.toString(),
      position: result.currentIndex,
    };
    this.frequencybpService
      .updatePosition(
        this.currentUpdateSubRoute._id.toString(),
        result.container.id.split("-")[1],
        businessPartnerPosition
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.frequencyService
            .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
            .subscribe((data) => {
              this.currentUpdateSubRoute.frequency = data?.data;
              this.groupDataByFrequencyType({ filteredData: data?.data });
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }
  updateFrequency(result): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.UPDATE, "No tienes permisos para actualizar frecuencias.")) {
      return;
    }

    this.currentCreateFrequency = {
      ...result,
      dates: result.dates ? [result.dates] : [],
      businessPartners: result.businessPartners.map((b, index) => ({
        businessPartnerId: b,
        position: index + 1,
      })),
    };
    this.frequencyService
      .updateEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        result._id.toString(),
        this.currentCreateFrequency
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.frequencyService
            .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
            .subscribe((data) => {
              this.currentUpdateSubRoute.frequency = data?.data;
              this.filteredData = new MatTableDataSource(
                this.currentUpdateSubRoute.frequency
              );
              this.groupDataByFrequencyType({ filteredData: data?.data });
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  async initializeComboBox() {
    this.fetchAllCompanies();
    this.fetchAllRoute();
    this.fetchRouteArea();
    this.fetchAllSubRouteFunction();
    this.fetchAllVehicle();
    this.fetchAllSalesOffice();
    this.fetchAllSubRutas();
    this.fetchAllWarehouses();
    this.fetchRouteGroup();
    this.fetchAllBusinessTypes();
    this.getFilterBusinessTypes();
    this.fetchRoute();
    this.fetchRouteC();
    this.fetchRouteGroup();
    // this.fetchAllUserMaster();
    this.modelList = Object.entries(SubRouteModelEnum).map(([key, value]) => ({
      key: key as SubRouteModelEnum, // Aseguramos el tipo correcto
      value,
    }));
    this.typeList = Object.entries(SubRouteTypeEnum).map(([key, value]) => ({
      key: key as SubRouteTypeEnum, // Aseguramos el tipo correcto
      value,
    }));
    this.useGpsList = [
      { key: "PERMISSIVE", value: PermissionModeEnum.PERMISSIVE },
      { key: "RESTRICTIVE", value: PermissionModeEnum.RESTRICTIVE },
      { key: "COMPANY_BASED", value: PermissionModeEnum.COMPANY_BASED },
    ];
  }

  private checkIfHasPermission(permission: string, errorMessage?: string): boolean {
    const has = this.permissionService.has(permission);
    if (!has && errorMessage) {
      this.handlerMessage.error({
        message: errorMessage,
      });
    }
    return has;
  }

  openRelationshipsModal(): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ASSOCIATIONS.VIEW, 'No tienes permisos para ver las relaciones de ruta.')) {
      return;
    }
    this.dialog.open(SubRouteRelationshipsModalComponent, {
      width: '90%',
      maxWidth: '1200px',
      maxHeight: '90vh',
      panelClass: 'responsive-modal',
    });
  }

  openClientRouteLocator(): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ASSOCIATIONS.BUSINESS_PARTNER, "No tienes permisos para asignar territorios.")) {
      return;
    }

    const dialogRef = this.dialog.open(ClientRouteLocatorComponent, {
      width: "95%",
      maxWidth: "1400px",
      height: "95%",
      maxHeight: "1200px",
      disableClose: false,
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  async openCreateModal(): Promise<void> {
    if (!this.checkIfHasPermission(this.PERMISSIONS.CREATE, "No tienes permisos para crear rutas.")) {
      return;
    }

    this.currentUpdateSubRoute = null;
    this.currentCreateSubRoute = this.initializeCreateSubRoute();
    await this.fetchAllUserMaster();
    this.initializeComboBox();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      width: "95%",
      maxWidth: "1100px",
      height: "95%",
      maxHeight: "1100px",
    });
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createSubRoute());
    this.dialogRefAdd.afterClosed().subscribe((result) => {
      result;
    });
  }
  async openEditModal(subRoute: SubRouteAttributes): Promise<void> {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tienes permisos para editar rutas.")) {
      return;
    }

    await this.fetchAllUserMaster();
    this.fetchAllBusinessTypes();
    this.originalEditMasterUserId = this.getMasterUserId(subRoute.mainCollaborator?.masterUserId);
    this.originalEditResponsibleId = subRoute.responsibleBusinessPartner?._id?.toString() ?? "";
    let selectedUserMaster;
    let selectedBusinessFunction;
    if (subRoute.mainCollaborator) {
      selectedUserMaster = this.userMasterList.find(
        (group) => group.masterUserId === subRoute.mainCollaborator.masterUserId
      );
      if (selectedUserMaster) {
        this.mainCollabList.push(selectedUserMaster);
      }
      if (subRoute.mainCollaborator.businessPartnerFunction) {
        selectedBusinessFunction = this.businessPartnerFunctionList.find(
          (bf) =>
            bf._id.toString() ===
            subRoute.mainCollaborator.businessPartnerFunction._id.toString()
        );
      } else {
        selectedBusinessFunction = {
          _id: "",
          name: "",
        };
      }
    } else {
      selectedUserMaster = {
        masterUserId: "",
        username: "",
      };
    }

    const collaboratorWithUsername = {
      masterUserId: selectedUserMaster,
      businessPartnerFunction: selectedBusinessFunction,
    };

    this.currentUpdateSubRoute = {
      ...(subRoute as any),
      mainCollaborator: collaboratorWithUsername,
      responsibleBusinessPartnerId:
        subRoute.responsibleBusinessPartner?._id ?? null,
      externalKeys: {
        code: subRoute?.externalKeys?.code ?? null,
      },
      distanceBtwSellerAndCustomer: subRoute.distanceBtwSellerAndCustomer ?? 0,
      forceCloseTripPastEndDate:
        subRoute.forceCloseTripPastEndDate ?? ForceCloseTripEnum.FORCE,
      invoicedDeliveryCollectionBehaviour: subRoute.invoicedDeliveryCollectionBehaviour ?? InvoicedDeliveryCollectionBehaviourEnum.NEVER_ASK,
      deliveryAssignmentStrategy: subRoute.deliveryAssignmentStrategy
      ?? (subRoute.allowDeliveryDateChange === true
          ? DeliveryAssignmentStrategyEnum.AUTO_EDITABLE
          : DeliveryAssignmentStrategyEnum.AUTO_NOT_EDITABLE),
      commercialConditionMode:
        subRoute.commercialConditionMode ?? CommercialCondModeEnum.SHIP_TO_ONLY
    };

    this.initializeComboBox();

    if (subRoute.plant && subRoute.plant?._id) {
      //this.fetchAllWarehouseByPlant(subRoute.plant._id.toString());
      this.fetchAllWarehouses();
    }
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      width: "95%",
      maxWidth: "1100px",
      height: "95%",
      maxHeight: "1200px",
    });
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateSubRoute(subRoute._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => {
      result;
    });
  }

  createSubRoute(): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.CREATE, "No tienes permisos para realizar esta acción.")) {
      return;
    }

    const functionItem = this.functionList.find(
      (item) =>
        item._id.toString() === this.currentCreateSubRoute.subRouteFunctionId
    );
    if (this.currentCreateSubRoute.mainCollaborator.masterUserId == "") {
      this.currentCreateSubRoute.mainCollaborator = null;
    }
    this.currentCreateSubRoute.routeIds = this.routeMultiCtrl.value.map(
      (route: RouteAttributes) => route._id.toString()
    );

    this.currentCreateSubRoute.routeAreaIds = this.routeAreaMultiCtrl.value.map(
      (routeArea: RouteAreaAttributes) => routeArea._id.toString()
    );

    this.currentCreateSubRoute.warehouseIds = this.warehouseMultiCtrl.value.map(
      (warehouse: WarehouseAttributes) => warehouse._id.toString()
    );

    (this.currentCreateSubRoute.delSubRouteToEventualCustomerId =
      this.subrouteMultiCtrl.value?.toString() || null),
      (this.currentCreateSubRoute.delSubRouteToFinalConsumerId =
        this.subrouteCMultiCtrl.value?.toString() || null),
      (this.currentCreateSubRoute.model = functionItem.model);
    this.currentCreateSubRoute.responsibleBusinessPartnerId = this
      .currentCreateSubRoute.responsibleBusinessPartnerId
      ? this.currentCreateSubRoute.responsibleBusinessPartnerId
      : null;

    this.currentCreateSubRoute.vehicleId =
      this.subRouteFunctionSelected &&
      this.subRouteFunctionSelected.vehicleRequired == true &&
      this.vehicleCtrl.value
        ? this.vehicleCtrl.value._id.toString()
        : null;

    if (this.currentCreateSubRoute.useGps === false)
      this.currentCreateSubRoute.distanceBtwSellerAndCustomer = 0;

    const dataToSend: any = Object.entries(this.currentCreateSubRoute).reduce(
      (acc, [key, value]) => {
        if (value !== "" && !(Array.isArray(value) && value.length === 0)) {
          // Ignora cadenas vacías y arreglos vacíos
          acc[key] = value;
        }
        return acc;
      },
      {}
    );

    this.subrouteService.create(dataToSend).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.findAllWithCount();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 5000, verticalPosition: "top" }
        );
      },
    });
    this.routeMultiCtrl.reset();
    this.routeAreaMultiCtrl.reset();
    this.masterUserMultiCtrl.reset();
    this.routeGroupMultiCtrl.reset();
    this.vehicleCtrl.reset();
  }

  manualCreateTripsForSubRoute(): void {
    if (this.isCreatingTripsFromItinerary) {
      return;
    }

    if (!this.checkIfHasPermission(this.PERMISSIONS_TRIPS.VIEW, "No tienes permisos para ver los viajes de la ruta.")) {
      return;
    }

    if (!this.canCreateTripsFromItinerary()) {
      this.snackBar.open("La ruta debe tener usuario y responsable para generar viajes", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
      return;
    }

    // FS-290: the backend evaluates the saved route with the job's own rules before anything
    // is created; the create request is only sent when it says trips would be created.
    this.isCreatingTripsFromItinerary = true;
    this.tripRouteService
      .previewManualCreateTripJob(this.currentUpdateSubRoute._id.toString(), 7)
      .pipe(finalize(() => (this.isCreatingTripsFromItinerary = false)))
      .subscribe({
        next: (res) => {
          const preview = res?.data;
          if (!preview) {
            this.showCreateTripsPreviewError();
            return;
          }
          if (isCreateTripsPreviewBlocked(preview)) {
            this.showCreateTripsBlocked(preview);
          } else {
            this.confirmManualTripCreation(preview);
          }
        },
        error: (err: { error?: { message?: string } }) => {
          this.showCreateTripsPreviewError(err?.error?.message);
        },
      });
  }

  private showCreateTripsBlocked(preview: TripCreationPreviewResult): void {
    this.confirmationService
      .confirm({
        title: preview.blockingReason
          ? t('routing.SUB_ROUTES.CREATE_TRIPS_PREVIEW.BLOCKED_TITLE')
          : t('routing.SUB_ROUTES.CREATE_TRIPS_PREVIEW.NO_TRIPS_TITLE'),
        description: buildCreateTripsBlockedMessage(preview),
        type: ConfirmationModalType.WARNING,
        confirmButtonText: "Entendido",
        cancelButtonText: '',
        descriptionIcon: 'event_busy',
        customWidth: '520px',
      })
      .subscribe();
  }

  private confirmManualTripCreation(preview: TripCreationPreviewResult): void {
    this.confirmationService
      .confirm({
        title: "Crear viajes a partir de itinerario",
        description: buildCreateTripsConfirmMessage(preview),
        type: ConfirmationModalType.WARNING,
        confirmButtonText: "Generar viajes",
        cancelButtonText: "Cancelar",
        descriptionIcon: "auto_awesome",
        customWidth: "480px",
      })
      .subscribe((confirmed) => {
        if (confirmed) {
          this.runManualTripCreation();
        }
      });
  }

  /**
   * FS-290: the button only applies to active delivery / auto-sale routes with user and
   * responsible, read from the saved route (the one the preview evaluates).
   */
  canShowCreateTripsFromItinerary(): boolean {
    const current = this.currentUpdateSubRoute;
    return (
      current?.statusId === StatusEnum.ACTIVE &&
      CREATE_TRIPS_FROM_ITINERARY_MODELS.includes(current?.model) &&
      this.canCreateTripsFromItinerary()
    );
  }

  private showCreateTripsPreviewError(message?: string): void {
    this.snackBar.open(message || t("routing.SUB_ROUTES.CREATE_TRIPS_PREVIEW.PREVIEW_ERROR"), "Cerrar", {
      duration: 5000,
      verticalPosition: "top",
    });
  }

  private runManualTripCreation(): void {
    this.isCreatingTripsFromItinerary = true;

    this.tripRouteService
      .manualCreateTripJob(7, this.currentUpdateSubRoute._id.toString())
      .pipe(finalize(() => (this.isCreatingTripsFromItinerary = false)))
      .subscribe({
        next: (response) => {
          const responseData = response?.data;
          const nestedData = responseData && typeof responseData === "object" && !Array.isArray(responseData)
            ? (responseData as { data?: unknown }).data
            : undefined;
          const trips = Array.isArray(responseData)
            ? responseData
            : Array.isArray(nestedData)
              ? nestedData
              : [];

          console.info("[SubRoute] respuesta de generación de viajes", response);
          if (!trips.length) {
            this.snackBar.open("No se crearon viajes nuevos porque ya existen viajes vigentes", "Cerrar", {
              duration: 5000,
              verticalPosition: "top",
            });
            return;
          }
          this.dialog.open(ModalCreatedTripsComponent, {
            width: "95vw",
            maxWidth: "900px",
            data: {
              allCreatedTrips: trips,
              currentSubRouteMongoId: this.currentUpdateSubRoute._id.toString(),
              currentSubRouteName: this.currentUpdateSubRoute.name,
            },
          });
        },
        error: (error) => {
          this.snackBar.open(error?.error?.message || "Error al generar viajes desde el itinerario", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
        },
      });
  }

  canCreateTripsFromItinerary(): boolean {
    const current = this.currentUpdateSubRoute;
    const masterUser = (current?.mainCollaborator as unknown as { masterUserId?: unknown } | undefined)?.masterUserId;
    const masterUserId = this.getMasterUserId(masterUser);
    const responsibleId = (current as unknown as { responsibleBusinessPartnerId?: unknown } | undefined)
      ?.responsibleBusinessPartnerId ?? current?.responsibleBusinessPartner?._id;

    return Boolean(current?._id && masterUserId && responsibleId);
  }

  updateSubRoute(id: string): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tienes permisos para realizar esta acción.")) {
      return;
    }

    if (this.currentUpdateSubRoute) {
      const functionItem = this.functionList.find(
        (item) =>
          item._id.toString() ===
          this.currentUpdateSubRoute.function._id.toString()
      );

      const previousMasterUserId = this.originalEditMasterUserId;
      const previousResponsibleId = this.originalEditResponsibleId;

      // Aquí verificamos si el valor de masterUserId ha cambiado
      const currentMasterUserId: any =
        this.currentUpdateSubRoute.mainCollaborator?.masterUserId;
      // Si no se encontró

      if (!currentMasterUserId) {
        this.snackBar.open(
          "El colaborador principal no existe o fue eliminado",
          "Cerrar",
          { duration: 5000, verticalPosition: "top" }
        );
      }

      // Si no se modificó el masterUserId, solo enviamos el ID
      const masterUserIdToSend =
        currentMasterUserId && currentMasterUserId.masterUserId
          ? currentMasterUserId.masterUserId.toString() // Si es un objeto, enviamos solo el ID
          : currentMasterUserId; // Si no es un objeto, ya está listo para enviar

      if (!masterUserIdToSend || masterUserIdToSend?.masterUserId == "") {
        this.currentUpdateSubRoute.mainCollaborator = null;
      } else {
        this.currentUpdateSubRoute.mainCollaborator = {
          masterUserId: masterUserIdToSend,
        };
      }

      const updatedSubRoute: IUpdateSubRoute = {
        ...this.currentUpdateSubRoute,
        companyId: this.currentUpdateSubRoute.company._id.toString(),
        salesOfficeId: this.currentUpdateSubRoute.salesOffice._id.toString(),
        warehouseIds: this.warehouseMultiCtrl.value.map((ware) =>
          ware._id.toString()
        ),
        routeIds: this.routeMultiCtrl.value.map((material: RouteAttributes) =>
          material._id.toString()
        ),

        routeAreaIds: this.routeAreaMultiCtrl.value.map((rou) =>
          rou._id.toString()
        ),
        delSubRouteToEventualCustomerId:
          this.subrouteMultiCtrl.value?.toString() || null,
        delSubRouteToFinalConsumerId:
          this.subrouteCMultiCtrl.value?.toString() || null,
        routeGroupId: this.currentUpdateSubRoute.routeGroup._id.toString(),
        // deliverySubRouteId: this.currentUpdateSubRoute.deliverySubRoute._id.toString(),
        // model: "",
        subRouteFunctionId: this.currentUpdateSubRoute.function._id.toString(),
        plantId: this.currentUpdateSubRoute.plant
          ? this.currentUpdateSubRoute.plant._id.toString()
          : null,
        vehicleId:
          this.subRouteFunctionSelected &&
            this.subRouteFunctionSelected.vehicleRequired == true &&
            this.vehicleCtrl.value
            ? this.vehicleCtrl.value._id.toString()
            : null,
        model: functionItem.model,
        distanceBtwSellerAndCustomer:
          this.currentUpdateSubRoute.useGps === true
            ? this.currentUpdateSubRoute.distanceBtwSellerAndCustomer
            : 0,
        forceCloseTripPastEndDate:
          this.currentUpdateSubRoute.forceCloseTripPastEndDate ??
          ForceCloseTripEnum.FORCE,
        invoicedDeliveryCollectionBehaviour: this.currentUpdateSubRoute.invoicedDeliveryCollectionBehaviour ?? InvoicedDeliveryCollectionBehaviourEnum.NEVER_ASK,
        deliveryAssignmentStrategy: this.currentUpdateSubRoute.deliveryAssignmentStrategy ?? DeliveryAssignmentStrategyEnum.AUTO_NOT_EDITABLE,
        commercialConditionMode: this.currentUpdateSubRoute.commercialConditionMode ?? CommercialCondModeEnum.SHIP_TO_ONLY
      };
      const dataToSend: any = Object.entries(updatedSubRoute).reduce(
        (acc, [key, value]) => {
          if (value !== "" && !Array.isArray(value)) {
            acc[key] = value;
          }
          return acc;
        },
        {}
      );
      const nextMasterUserId = this.getMasterUserId(updatedSubRoute.mainCollaborator?.masterUserId);
      const nextResponsibleId = updatedSubRoute.responsibleBusinessPartnerId?.toString() ?? "";
      if (previousMasterUserId !== nextMasterUserId || previousResponsibleId !== nextResponsibleId) {
        const confirmationRef = this.dialog.open(RouteUpdateConfirmationComponent, {
          width: "520px",
          maxWidth: "95vw",
          disableClose: true,
          data: {
            routeName: this.currentUpdateSubRoute.name ||
              this.currentUpdateSubRoute.externalKeys?.code ||
              "seleccionada",
          },
        });
        confirmationRef.afterClosed().subscribe((confirmed) => {
          if (confirmed) {
            this.selectTripsForUpdate(
              this.currentUpdateSubRoute!,
              nextMasterUserId,
              nextResponsibleId,
              () => this.persistSubRouteUpdate(id, updatedSubRoute)
            );
          }
        });
        return;
      }

      this.subrouteService.update(id, updatedSubRoute).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.findAllWithCount();
          this.dialogRefEdit.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
    }
    this.routeMultiCtrl.reset();
    this.routeAreaMultiCtrl.reset();
    this.masterUserMultiCtrl.reset();
    this.routeGroupMultiCtrl.reset();
    this.vehicleCtrl.reset();
  }

  private getMasterUserId(value: unknown): string {
    if (!value) {
      return "";
    }
    if (typeof value === "object" && value !== null && "masterUserId" in value) {
      return String((value as { masterUserId?: unknown }).masterUserId ?? "");
    }
    return String(value);
  }

  private persistSubRouteUpdate(id: string, updatedSubRoute: IUpdateSubRoute): void {
    this.subrouteService.update(id, updatedSubRoute).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.findAllWithCount();
        this.dialogRefEdit.close();
      },
      error: (error) => {
        this.snackBar.open(
          error?.error?.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 5000, verticalPosition: "top" }
        );
      },
    });
  }

  private selectTripsForUpdate(
    subRoute: SubRouteAttributes,
    masterUserId: string,
    responsibleBusinessPartnerId: string,
    onSaved: () => void
  ): void {
    const filterQuery = {
      where: [{
        _deleted: { searchType: "eq", value: { value: false } },
        "subRoute.id": { searchType: "eq", value: { value: Number(subRoute.id) } },
        statusTripId: { searchType: "eq", value: { value: 2 } },
      }],
      orderBy: { dateHourStartTeoric: "ASC" },
      page: { pageIndex: 1, size: 50 },
    };

    this.tripRouteService.findTripsWithCountByTripv2(filterQuery).subscribe({
      next: (response) => {
        const responseData = response?.data;
        const trips = Array.isArray(responseData)
          ? responseData
          : responseData && typeof responseData === "object" && Array.isArray((responseData as { data?: unknown }).data)
            ? (responseData as { data: unknown[] }).data
            : [];

        if (!trips.length) {
          onSaved();
          return;
        }

        const dialogRef = this.dialog.open(ModalSelectTripsComponent, {
          width: "95vw",
              maxWidth: "1100px",
          disableClose: true,
          data: { trips: response, routeName: subRoute.name },
        });

        dialogRef.afterClosed().subscribe((selectedTrips) => {
          if (!selectedTrips?.length) {
            onSaved();
            return;
          }

          this.tripRouteService.updateTripUserAndResponsible({
            tripMongoIds: selectedTrips.map((trip) => trip._id.toString()),
            subRouteMongoId: subRoute._id.toString(),
            masterUserId: masterUserId || null,
            responsibleBusinessPartnerId: responsibleBusinessPartnerId || null,
          }).subscribe({
            next: () => {
              this.snackBar.open("Viajes actualizados exitosamente", "Cerrar", { duration: 5000 });
              onSaved();
            },
            error: (error) => {
              this.snackBar.open(
                error?.error?.message || "Error al actualizar los viajes",
                "Cerrar",
                { duration: 5000 }
              );
              onSaved();
            },
          });
        });
      },
      error: () => onSaved(),
    });
  }

  onStatusChange(event: boolean, subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tienes permisos para cambiar el estado.")) {
      return;
    }

    const originalStatusId = subRoute.statusId;
    const updatedStatusId = event ? 1 : 0;

    const updatedSubRoute: IUpdateSubRoute = {
      ...subRoute,
      statusId: updatedStatusId,
    };
    this.subrouteService
      .update(subRoute._id.toString(), updatedSubRoute)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          subRoute.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.findAllWithCount();
        },
      });
  }

  onStatusFrequency(event: boolean, frequency: FrequenciesAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.UPDATE, "No tienes permisos para cambiar el estado de frecuencias.")) {
      return;
    }

    const originalStatusId = frequency.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedFrequency: any = {
      statusId: updatedStatusId,
    };
    this.frequencyService
      .updateEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        frequency._id.toString(),
        updatedFrequency
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.frequencyService
            .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
            .subscribe((data) => {
              this.currentUpdateSubRoute.frequency = data?.data;
              this.groupDataByFrequencyType({ filteredData: data?.data });
            });
        },
        error: (err) => {
          frequency.statusId = originalStatusId;
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      });
  }

  onitineraryStatusChange(
    event: boolean,
    routingItinerary: RoutingItineraryAttributes
  ): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY.UPDATE, "No tienes permisos para cambiar el estado del itinerario.")) {
      return;
    }

    const updatedStatusId = event ? 1 : 0;

    routingItinerary.statusId = updatedStatusId;
    this.updateItinerary(routingItinerary, 1);
  }

  onitineraryAlternativeStatusChange(
    event: boolean,
    routingItinerary: RoutingItineraryAttributes
  ): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE, "No tienes permisos para cambiar el estado del itinerario alternativo.")) {
      return;
    }

    const updatedStatusId = event ? 1 : 0;

    routingItinerary.statusId = updatedStatusId;
    this.updateItinerary(routingItinerary, 2);
  }

  openAuditLog(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.VIEW_AUDIT_LOG, "No tienes permisos para ver la bitácora de rutas.")) {
      return;
    }

    this.auditLogViewerService.open({
      documentIdentifiers: { id: subRoute.id },
      entityName: subRoute.name,
      collectionName: AUDIT_LOG_COLLECTIONS.SUB_ROUTE,
    });
  }

  openDeleteDialog(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.DELETE, "No tienes permisos para eliminar rutas.")) {
      return;
    }

    this.dialog
      .open(this.deleteDialog, {
        data: subRoute,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.delete(subRoute._id.toString()));
  }

  delete(id: string): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.DELETE, "No tienes permisos para eliminar rutas.")) {
      return;
    }

    this.subrouteService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
    });
  }

  openDeleteFrequency(item: any): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.DELETE, "No tienes permisos para eliminar frecuencias.")) {
      return;
    }

    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteFrequency(item));
  }

  deleteFrequency(item: any): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_FREQUENCIES.DELETE, "No tienes permisos para eliminar frecuencias.")) {
      return;
    }

    this.frequencyService
      .deleteEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Frecuencia eliminada con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.frequencyService
          .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
          .subscribe((data) => {
            this.currentUpdateSubRoute.frequency = data?.data;
            this.filteredData = new MatTableDataSource(
              this.currentUpdateSubRoute.frequency
            );
            this.groupDataByFrequencyType({ filteredData: data?.data });
          });
      });
  }

  getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
    return selectedCompanyIds.map(
      (id) => this.companyList.find((group) => group._id.toString() === id)?.id
    );
  }

  onRouteSelectionChange(routeIds: string[]): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.routes = routeIds.map((routeId) =>
        this.routeList.find((r) => r._id.toString() == routeId)
      );
    }
  }

  onRouteAreaSelectionChange(routeIds: string[]): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.routeAreas = routeIds.map((routeId) =>
        this.routeAreaList.find((r) => r._id.toString() == routeId)
      );
    }
  }

  onBusinessFunctionSelectionChange(functionId: string): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.mainCollaborator.businessPartnerFunction =
        this.businessPartnerFunctionList.find(
          (b) => b._id.toString() === functionId
        )!;
    }
  }

  onuserMasterSelectionChange(userMasterId: string): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.mainCollaborator.masterUserId =
        this.userMasterList.find((b) => b._id.toString() === userMasterId)!;
    }
  }

  onSalesOfficeSelectionChange(salesOfficeId: string): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.salesOffice = this.salesOfficeList.find(
        (sales) => sales._id.toString() === salesOfficeId
      )!;
    }
  }

  onRouteGroupSelectionChange(routeGroupId: string): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.routeGroup = this.routeGroupList.find(
        (group) => group._id.toString() === routeGroupId
      )!;
    }
  }

  onFunctionSelectionChange(functionId: string): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.function = this.functionList.find(
        (f) => f._id.toString() === functionId
      )!;
    }
  }

  onCompanySelectionChange(companyId: string): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.company = this.companyList.find(
        (f) => f._id.toString() === companyId
      )!;
    }
  }

  onWarehouseSelectionChange(warehousesId: string[]): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.warehouses = warehousesId.map(
        (warehouseId) =>
          this.warehouseList.find((w) => w._id.toString() === warehouseId)!
      );
    }
  }
  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  compareByMaster(item1, item2) {
    return item1 && item2
      ? item1.masterUserId === item2.masterUserId
      : item1 === item2;
  }

  compareByRes(item1, item2) {
    return item1 && item2 ? item1._id === item2 : item1 === item2;
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.routeMultiCtrl.setValue([]);
    this.routeAreaMultiCtrl.setValue([]);
    this.masterUserMultiCtrl.setValue([]);
    this.routeGroupMultiCtrl.setValue([]);
    this.searchService.clear();
    this.form.reset({
      companyIds: [],
      routeIds: [],
      routeAreaIds: [],
      assignedUserId: [],
      routeGroupIds: [],
    });
    this.findAllWithCount();
  }

  openDeleteOrder(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteOrder(item));
  }

  deleteOrder(item: any): void {
    this.subRouteOrderService
      .deleteEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Frecuencia eliminada con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.subRouteOrderService
          .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
          .subscribe((data) => {
            this.currentUpdateSubRoute.orderDeliveryWindows = data?.data;
          });
      });
  }

  openDeleteCollaborator(item: any): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_INTERLOCUTORS.DELETE, "No tienes permisos para eliminar interlocutores.")) {
      return;
    }

    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteCollaborator(item));
  }

  deleteCollaborator(item: any): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_INTERLOCUTORS.DELETE, "No tienes permisos para eliminar interlocutores.")) {
      return;
    }

    this.subRouteCollaboratorService
      .deleteEmbedded(
        this.currentUpdateSubRoute._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.snackBar.open("Colaborador eliminado con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.subRouteCollaboratorService
          .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
          .subscribe((data) => {
            this.currentUpdateSubRoute.collaborators = data?.data;
          });
      });
  }

  openDeleteItinerary(item: any, type): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY.DELETE, "No tienes permisos para eliminar itinerarios.")) {
      return;
    }

    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteItinerary(item, type));
  }

  deleteItinerary(item: any, type): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY.DELETE, "No tienes permisos para eliminar itinerarios.")) {
      return;
    }

    this.routingItineraryService.remove(item._id.toString()).subscribe(() => {
      this.snackBar.open("Itinerario eliminado con éxito", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
      if (type == 1) {
        this.getRoutingItineraryByType(RoutingItineraryTypesEnum.SUB_ROUTE);
      } else {
        this.getRoutingItineraryByType(
          RoutingItineraryTypesEnum.SUB_ROUTE_ALTERNATIVE
        );
      }
    });
  }

  openDeleteItineraryAlternative(item: any): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY_ALTERNATIVE.DELETE, "No tienes permisos para eliminar itinerarios alternativos.")) {
      return;
    }

    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteItineraryAlternative(item));
  }

  deleteItineraryAlternative(item: any): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ITINERARY_ALTERNATIVE.DELETE, "No tienes permisos para eliminar itinerarios alternativos.")) {
      return;
    }

    this.routingItineraryService.remove(item._id.toString()).subscribe(() => {
      this.snackBar.open("Itineario eliminada con éxito", "Cerrar", {
        duration: 5000,
        verticalPosition: "top",
      });
      this.getRoutingItineraryByType(
        RoutingItineraryTypesEnum.SUB_ROUTE_ALTERNATIVE
      );
    });
  }

  getListItinerary() {
    this.itineraryService
      .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
      .subscribe((data) => {
        //this.currentUpdateSubRoute.itinerary = data?.data;
        this.currentUpdateSubRoute.itinerary = data?.data.sort(
          (a, b) => Math.min(...a.days) - Math.min(...b.days)
        );
      });
  }

  getListAlternativeItinerary() {
    this.itineraryAlternativeService
      .findBySubRouteId(this.currentUpdateSubRoute._id.toString())
      .subscribe((data) => {
        this.currentUpdateSubRoute.alternaviteItinerary = data?.data;
      });
  }

  getRoutingItineraryByType(type: string) {
    this.routingItineraryService
      .findBySubRouteIdAndType(this.currentUpdateSubRoute._id.toString(), type)
      .subscribe((data) => {
        switch (type) {
          case "SUB_ROUTE":
            this.dataSourceItinerary.data = data?.data;
            break;
          case "SUB_ROUTE_ALTERNATIVE":
            this.dataSourceItineraryAlternative.data = data?.data;
            break;
          default:
            break;
        }
      });
  }

  //Cambiar Usuario Asociado
  openChangeMainCollaboratorModal(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_ASSOCIATIONS.USERS_CHANGE, "No tienes permisos para cambiar el usuario asociado.")) {
      return;
    }

    const dialogRef = this.dialog.open(ChangeMainCollaboratorModalComponent, {
      panelClass: ".form-modal-interlocutor",
      data: { subRoute },
      width: "600px",
      maxWidth: "95vw",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.findAllWithCount();
      }
    });
  }


  /**
 * This function returns the query parameters for the emission point route.
 * @param {SubRouteAttributes} subRoute - The sub route to get the query parameters for.
 * @returns {object} The query parameters for the emission point route.
 * @example
 * getNavigateToEmissionPointQueryParams(subRoute); // Returns {subRouteId: string, subRouteCode: string, subRouteName: string}
 */
  getNavigateToEmissionPointWithSubRouteQueryParams(subRoute: SubRouteAttributes): { subRouteId: string, subRouteCode: string, subRouteName: string } {
    return {
      subRouteId: subRoute.id.toString(),
      subRouteCode: subRoute?.externalKeys?.code,
      subRouteName: subRoute.name
    }
  }

  //Colaboradores
  openAddCollabModal(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_INTERLOCUTORS.VIEW, "No tienes permisos para ver los interlocutores de ruta.")) {
      return;
    }

    const dialogRef = this.dialog.open(AddSubRouteCollaborator, {
      panelClass: ".form-modal-interlocutor",
      data: subRoute,
      width: "800px",
      disableClose: true,
    });
   
  }

  //Horarios de entrega
  openDeliveryTimesModal(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_DELIVERY_WINDOWS.VIEW, "No tienes permisos para ver las ventanas horarias.")) {
      return;
    }

    const dialogRef = this.dialog.open(AddSubRouteDeliveryTimes, {
      panelClass: ".form-modal-interlocutor",
      data: subRoute,
      width: "850px",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  //frecuencia
  /** Abre el modal de optimización de rutas para la sub-ruta de la fila. */
  openOptimizationDrawer(subRoute: SubRouteAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tienes permisos para optimizar rutas.")) {
      return;
    }

    this.dialog.open(RouteOptimizationDrawerComponent, {
      data: subRoute,
      width: "1100px",
      maxWidth: "95vw",
      height: "88vh",
      panelClass: "route-optimization-modal-panel",
      autoFocus: false,
      injector: this.injector,
    });
  }

  /**
   * Opens the sub route partners screen, which manages assigned and unassigned customers and
   * holds the bulk GPS update. Both the route type icon and the calendar button open it; the
   * legacy periodicity modal is no longer reachable from this list.
   */
  openSubRoutePartners(subRoute: SubRouteAttributes): void {
    this.dialog.open<SubRoutePartnersDialogComponent, SubRoutePartnersDialogData>(
      SubRoutePartnersDialogComponent,
      {
        panelClass: "full-screen-dialog",
        data: subRoute,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "100%",
        injector: this.injector,
      }
    );
  }

  private loadPlants(): void {
    if (this.plantsLoaded) return;
    this.plantsLoaded = true;
    this.plantService.findToComboBox().subscribe({
      next: (response: any) => {
        this.plants = response.data || [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener plantas.", "Cerrar", { duration: 5000 });
      },
    });
  }
  private fetchAllWarehouseByPlant(plantId: string): void {
    this.warehouseService.findToComboBox(plantId).subscribe({
      next: (res) => {
        this.warehouseList = res.data;
        this.filteredWarehouses.next(this.warehouseList);

        this.filteredWarehouses.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateSubRoute?.warehouses
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.warehouseMultiCtrl.setValue(selectedMaterials);
        });

        // Listen for search field value changes
        this.warehouseMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterWarehouseMulti();
            this.setToggleAllCheckboxStateWarehouse();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener almacenes por plantas.", "Cerrar", { duration: 5000 });
      },
    });
  }

  // onPlantSelectionChange(plantId: string): void {
  //   // Encuentra el objeto completo de la planta seleccionada
  //   const selectedPlant = this.plants.find((plant) => plant._id === plantId);

  //   // Actualiza el modelo según el contexto
  //   if (this.currentCreateSubRoute) {
  //     this.currentCreateSubRoute.plantId = selectedPlant?._id; // Actualiza el ID en la creación
  //   }
  //   if (this.currentUpdateSubRoute) {
  //     this.currentUpdateSubRoute.warehouses = [];
  //     this.currentUpdateSubRoute.plant = this.plants.find(
  //       (f) => f._id.toString() === plantId
  //     )!;
  //   }

  // Maneja la lógica de almacenes
  //   if (plantId) {
  //     this.fetchAllWarehouseByPlant(plantId); // Lógica existente
  //   } else {
  //     this.warehouseList = [];
  //     this.filteredWarehouses.next([]);
  //     this.warehouseMultiCtrl.setValue([]);
  //   }
  // }

  onPlantSelectionChange(plantId: string): void {
    if (this.currentUpdateSubRoute) {
      this.currentUpdateSubRoute.plant = this.plants.find(
        (plant) => plant._id.toString() === plantId
      )!;
    }
  }

  getRouteNames(routes: any[]): string {
    return routes.map((route) => route.name).join(", ");
  }

  downloadSubRouteTemplate() {
    const url = this.subrouteService.getFileTemplateSubRoute();
    if (!url) {
      this.snackBar.open("Plantilla no disponible.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    window.open(url);
  }

  async handleFileInput(event) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPLOAD, "No tienes permisos para importar rutas.")) {
      return;
    }

    this.aux_file = true;
    this.fileToUpload = event.target.files[0];
    if (this.fileToUpload) {
      if (
        this.fileToUpload.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.snackBar.open("Ingrese solo de tipo .xlsx", "Cerrar", {
          duration: 3000,
        });
      }
    } else {
      this.aux_file = false;
    }
  }

  onConfirmImportFile(fileInput: HTMLInputElement) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPLOAD, "No tienes permisos para importar rutas.")) {
      return;
    }

    if (this.fileToUpload) {
      let send = {
        file: this.fileToUpload,
      };
      let formdata = new FormData();
      for (let key in send) {
        formdata.append(key, send[key]);
      }

      this.subrouteService.importFile(formdata).subscribe({
        next: (res: any) => {
          this.snackBar.open(res.message, "Cerrar", { duration: 3000 });
          this.aux_file = false;
          this.fileToUpload = null;
          fileInput.value = "";
          this.findAllWithCount();
        },
        error: (err) => {
          this.aux_file = false;
          this.fileToUpload = null;
          fileInput.value = "";
          this.snackBar.open(
            err.error.message || "Error al subir el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  //exportar
  onExportButtonPressed() {
    if (!this.checkIfHasPermission(this.PERMISSIONS.EXPORT, "No tienes permisos para exportar rutas.")) {
      return;
    }

    if (!this.subRouteExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: SUB_ROUTE_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.subRouteExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  removeAction(action: string, element?): void {
    if (element) {
      element.action = element.action.filter((a) => a !== action);
    } else {
      this.currentCreateRoutingItineraryActions =
        this.currentCreateRoutingItineraryActions.filter((a) => a !== action);
    }
  }

  removeActionAlternative(action: string, element?): void {
    if (element) {
      element.action = element.action.filter((a) => a !== action);
    } else {
      this.currentCreateRoutingItineraryAlternativeActions =
        this.currentCreateRoutingItineraryAlternativeActions.filter(
          (a) => a !== action
        );
    }
  }

  onActionSelectionChange(event: MatSelectChange, element?): void {
    const currentValues = event.value as string[];
    const previousValues = element
      ? element.action
      : this.currentCreateRoutingItineraryActions;

    const added = currentValues.find((v) => !previousValues.includes(v));
    const removed = previousValues.find((v) => !currentValues.includes(v));

    if (added) {
      if (element) {
        element.action = [...previousValues, added];
      } else {
        this.currentCreateRoutingItineraryActions = [...previousValues, added];
      }
    }

    if (removed) {
      if (element) {
        element.action = previousValues.filter((v) => v !== removed);
      } else {
        this.currentCreateRoutingItineraryActions = previousValues.filter(
          (v) => v !== removed
        );
      }
    }
  }

  onActionAlternativeSelectionChange(event: MatSelectChange, element?): void {
    const currentValues = event.value as string[];
    const previousValues = element
      ? element.action
      : this.currentCreateRoutingItineraryAlternativeActions;

    const added = currentValues.find((v) => !previousValues.includes(v));
    const removed = previousValues.find((v) => !currentValues.includes(v));

    if (added) {
      if (element) {
        element.action = [...previousValues, added];
      } else {
        this.currentCreateRoutingItineraryAlternativeActions = [
          ...previousValues,
          added,
        ];
      }
    }

    if (removed) {
      if (element) {
        element.action = previousValues.filter((v) => v !== removed);
      } else {
        this.currentCreateRoutingItineraryAlternativeActions =
          previousValues.filter((v) => v !== removed);
      }
    }
  }

  dropAction(event: CdkDragDrop<string[]>, element?: any): void {
    if (element) {
      moveItemInArray(element.action, event.previousIndex, event.currentIndex);
    } else {
      moveItemInArray(
        this.currentCreateRoutingItineraryActions,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  dropActionAlternative(event: CdkDragDrop<string[]>, element?: any): void {
    if (element) {
      moveItemInArray(element.action, event.previousIndex, event.currentIndex);
    } else {
      moveItemInArray(
        this.currentCreateRoutingItineraryAlternativeActions,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  async toggleDetails(itinerary: RoutingItineraryAttributes): Promise<void> {
    if (
      this.selectedItinerary &&
      this.selectedItinerary._id === itinerary._id
    ) {
      this.closeDetails();
      return;
    }

    this.selectedItinerary = itinerary;
    this.listItineraryDetail =
      this.selectedItinerary.detail && this.selectedItinerary.detail.length > 0
        ? this.selectedItinerary.detail
        : [];
  }

  async toggleDetailsAlternative(
    itineraryA: RoutingItineraryAttributes
  ): Promise<void> {
    if (
      this.selectedItineraryAlternative &&
      this.selectedItineraryAlternative._id === itineraryA._id
    ) {
      this.closeDetailsAlternative();
      return;
    }

    this.selectedItineraryAlternative = itineraryA;
    this.listItineraryAlternativeDetail =
      this.selectedItineraryAlternative.detail &&
        this.selectedItineraryAlternative.detail.length > 0
        ? this.selectedItineraryAlternative.detail
        : [];
  }

  closeDetails(): void {
    this.selectedItinerary = null;
  }

  closeDetailsAlternative(): void {
    this.selectedItineraryAlternative = null;
  }

  onAddToListRoutingItinerary(type) {
    if (type == 1) {
      if (
        this.currentCreateRoutingItineraryDay == null ||
        this.currentCreateRoutingItineraryActions.length == 0
      ) {
        this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        return;
      }

      if (
        this.dayAlreadyExists(
          this.selectedItinerary.detail,
          this.currentCreateRoutingItineraryDay
        )
      ) {
        this.snackBar.open("El día ya existe en la lista", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        return;
      }
    } else {
      if (
        this.currentCreateRoutingItineraryAlternativeDay == null ||
        this.currentCreateRoutingItineraryAlternativeActions.length == 0
      ) {
        this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        return;
      }

      if (
        this.dayAlreadyExists(
          this.selectedItineraryAlternative.detail,
          this.currentCreateRoutingItineraryAlternativeDay
        )
      ) {
        this.snackBar.open("El día ya existe en la lista", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        return;
      }
    }

    let detailToAdd: RoutingItineraryDetailAttributes = {
      day: null,
      action: null,
    };

    if (type == 1) {
      detailToAdd.day = this.currentCreateRoutingItineraryDay;
      detailToAdd.action = this.currentCreateRoutingItineraryActions;

      this.listItineraryDetail.push(detailToAdd);
      this.selectedItinerary.detail = this.listItineraryDetail;

      this.orderDaysArray(this.selectedItinerary.detail);
      this.updateItinerary(this.selectedItinerary, type == 1 ? 1 : 2);

      this.openFormAddRoutingItineraryDetail = false;
      this.currentCreateRoutingItineraryDay = null;
      this.currentCreateRoutingItineraryActions = [];
    } else {
      detailToAdd.day = this.currentCreateRoutingItineraryAlternativeDay;
      detailToAdd.action = this.currentCreateRoutingItineraryAlternativeActions;

      this.listItineraryAlternativeDetail.push(detailToAdd);
      this.selectedItineraryAlternative.detail =
        this.listItineraryAlternativeDetail;

      this.orderDaysArray(this.selectedItineraryAlternative.detail);
      this.updateItinerary(
        this.selectedItineraryAlternative,
        type == 1 ? 1 : 2
      );

      this.openFormAddRoutingItineraryAlternativeDetail = false;
      this.currentCreateRoutingItineraryAlternativeDay = null;
      this.currentCreateRoutingItineraryAlternativeActions = [];
    }

    //Validacion de itinerarios
    /*if (!this.isValidItineraryActions()) {

      this.selectedItinerary.detail = this.listItineraryDetail.filter(i => i.day != detailToAdd.day)
      this.listItineraryDetail = this.selectedItinerary.detail

      this.openFormAddRoutingItineraryDetail = true;
      return;
    }*/
  }

  onUpdateDetailItinerary(element, i) {
    this.openFormAddRoutingItineraryDetail = false;
    this.editDetailRoutingItineraryDetail = true;
  }

  onUpdateDetailItineraryAlternative(element, i) {
    this.openFormAddRoutingItineraryAlternativeDetail = false;
    this.editDetailRoutingItineraryAlternativeDetail = true;
  }

  onSaveDetailItinerary(type) {
    if (type == 1) {
      if (this.listItineraryDetail.length == 0) {
        this.snackBar.open("Ingrese un registro", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        return;
      }

      if (
        !this.listItineraryDetail.every(
          (item) => item.day !== null && item.action.length > 0
        )
      ) {
        this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        return;
      }

      this.editDetailRoutingItineraryDetail = false;

      this.orderDaysArray(this.selectedItinerary.detail);
      this.updateItinerary(this.selectedItinerary, type == 1 ? 1 : 2);
    } else {
      if (this.listItineraryAlternativeDetail.length == 0) {
        this.snackBar.open("Ingrese un registro", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        return;
      }

      if (
        !this.listItineraryAlternativeDetail.every(
          (item) => item.day !== null && item.action.length > 0
        )
      ) {
        this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        return;
      }

      this.editDetailRoutingItineraryAlternativeDetail = false;

      this.orderDaysArray(this.selectedItineraryAlternative.detail);
      this.updateItinerary(
        this.selectedItineraryAlternative,
        type == 1 ? 1 : 2
      );
    }
  }

  openDeleteDetailItinerary(element, index): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: element,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.listItineraryDetail.splice(index, 1);
          this.orderDaysArray(this.selectedItinerary.detail);
        }
      });
  }

  openDeleteDetailItineraryAlternative(element, index) {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: element,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.listItineraryAlternativeDetail.splice(index, 1);
          this.orderDaysArray(this.selectedItineraryAlternative.detail);
        }
      });
  }

  orderDaysArray(array) {
    array.sort((a, b) => a.day - b.day);
  }

  dayAlreadyExists(array, day) {
    return array.some((item) => item.day === day);
  }

  // onChangeEmissionPointTree() {
  //   this.findAllWithCount();
  // }

  getForceCloseTripLabel(forceCloseTrip: number): string {
    const labels = {
      [ForceCloseTripEnum.FORCE]: "Se obliga a cerrar el viaje",
      [ForceCloseTripEnum.ONLY_WARNING]:
        "Solo se advierte (no se obliga a cerrar el viaje)",
      [ForceCloseTripEnum.NONE]: "No se obliga a cerrar el viaje",
    };
    return labels[forceCloseTrip] || String(forceCloseTrip);
  }

  getInvoicedDeliveryCollectionBehaviourLabel(forceCloseTrip: number): string {
    const labels = {
      [InvoicedDeliveryCollectionBehaviourEnum.ALWAYS_ASK]: "Siempre consulta si se hará cobranza",
      [InvoicedDeliveryCollectionBehaviourEnum.ASK_IF_CASH_PAYMENT]:
        "Consulta solo si la condición de pago es Contado",
      [InvoicedDeliveryCollectionBehaviourEnum.NEVER_ASK]: "Nunca consulta",
    };
    return labels[forceCloseTrip] || String(forceCloseTrip);
  }

  getDeliveryAssignmentStrategyLabel(deliveryAssignmentStrategy: string): string {
    const labels = {
      [DeliveryAssignmentStrategyEnum.AUTO_EDITABLE]: 'Asignación automática Editable',
      [DeliveryAssignmentStrategyEnum.AUTO_NOT_EDITABLE]: 'Asignación automática No Editable',
      [DeliveryAssignmentStrategyEnum.MANUAL]: 'Asignación Manual',
    };
    return labels[deliveryAssignmentStrategy] || String(deliveryAssignmentStrategy);
  }

  getCommercialConditionModeLabel(commercialConditionMode: string): string {
    const labels = {
      [CommercialCondModeEnum.SHIP_TO_ONLY]: t(
        'routing.SUB_ROUTES.MESSAGES.COMMERCIAL_COND_SHIP_TO_ONLY'
      ),
      [CommercialCondModeEnum.SOLD_TO_ONLY]: t(
        'routing.SUB_ROUTES.MESSAGES.COMMERCIAL_COND_SOLD_TO_ONLY'
      ),
      [CommercialCondModeEnum.SHIP_TO_FALLBACK_SOLD_TO]: t(
        'routing.SUB_ROUTES.MESSAGES.COMMERCIAL_COND_SHIP_TO_FALLBACK_SOLD_TO'
      ),
      [CommercialCondModeEnum.FIRST_FOUND]: t(
        'routing.SUB_ROUTES.MESSAGES.COMMERCIAL_COND_FIRST_FOUND'
      ),
      [CommercialCondModeEnum.COMPANY_CONFIG]: t(
        'routing.SUB_ROUTES.MESSAGES.COMMERCIAL_COND_COMPANY_CONFIG'
      ),
      [CommercialCondModeEnum.HYBRID_SHIP_TO_DOMINANT]: t(
        'routing.SUB_ROUTES.MESSAGES.COMMERCIAL_COND_HYBRID_SHIP_TO_DOMINANT'
      ),
      [CommercialCondModeEnum.HYBRID_SOLD_TO_DOMINANT]: t(
        'routing.SUB_ROUTES.MESSAGES.COMMERCIAL_COND_HYBRID_SOLD_TO_DOMINANT'
      ),
    };
    return labels[commercialConditionMode] || String(commercialConditionMode);
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
    this.queryParamsSubscription?.unsubscribe();
  }

  routeTerritoryImportConfig: ImportConfig = {
    title: "para ruta-territorio",
    backendSheetName: "Ruta-Territorio",
    columns: [
      {
        key: "codigo_ruta",
        displayName: "Código Ruta",
        required: true,
        dataType: "string",
        excelColumnName: "Codigo_Ruta",
        validation: [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
        ],
        sticky: true,
      },
      {
        key: "nombre_ruta",
        displayName: "Nombre Ruta",
        required: false,
        dataType: "string",
        excelColumnName: "Nombre Ruta",
        validation: [Validators.maxLength(255)],
      },
      {
        key: "codigo_territorio",
        displayName: "Cod. Territorio",
        required: true,
        dataType: "string",
        excelColumnName: "Cod. Territorio",
        validation: [Validators.required, Validators.maxLength(50)],
      },
      {
        key: "nombre_territorio",
        displayName: "Nombre Territorio",
        required: false,
        dataType: "string",
        excelColumnName: "Nombre_Territorio",
        validation: [Validators.maxLength(255)],
      },
      {
        key: "action",
        displayName: "Acción",
        required: true,
        dataType: "string",
        excelColumnName: "Accion",
        validation: [
          Validators.required,
          Validators.pattern(
            /^(Asignación única|Extender asignación|Remover de todo)$/i
          ),
        ],
      },
    ],
    apiEndpoint: SUB_ROUTE_IMPORT_FILE_FULL_URL,
    maxFileSize: 10 * 1024 * 1024, // 10MB
    acceptedFileTypes: [".xlsx", ".xls"],
    customImportHandler: (data: any[], metadata?: any) =>
      this.handleRouteTerritoryImport(data, metadata),
  };

  async handleRouteTerritoryImport(data: any[], metadata?: any): Promise<any> {
    const fileName = metadata?.fileName || "route_territory.xlsx";
    const sheetName =
      this?.routeTerritoryImportConfig?.backendSheetName || "Ruta-Territorio";

    try {
      const excelFile = await this.excelGeneratorService.generateExcelFile(
        data,
        this.routeTerritoryImportConfig.columns,
        fileName,
        sheetName
      );

      // Create FormData to match the existing service expectation
      const formData = new FormData();

      // Add the generated Excel file (this is what the API expects)
      formData.append("file", excelFile, fileName);

      // Add the validated data as JSON for backend processing
      formData.append("validatedData", JSON.stringify(data));

      // Add metadata if available
      if (metadata) {
        formData.append("metadata", JSON.stringify(metadata));
      }

      // Call existing service method for Ruteo
      const response = (await this.subrouteService
        .importFile(formData)
        .toPromise()) as any;

      // Refresh data after successful import
      this.findAllWithCount();

      const processedResultData = response?.data?.result2;

      // Transform response to expected format
      return {
        success:
          processedResultData?.processResult?.errorCount === 0 ? true : false,
        data: processedResultData || {
          processResult: {
            totalRecords: data.length,
            validRecords: data.length,
            invalidRecords: [],
            createdCount: data.length,
            errorCount: 0,
          },
        },
        message:
          response?.message || "Importación de ruteo completada exitosamente",
      };
    } catch (error) {
      this.snackBar.open(error.error.message || "Error en importación de ruteo", "Cerrar", { duration: 5000 });
      throw error;
    }
  }
}
